//@ts-nocheck
import { ColDef, GridApi, GridReadyEvent, SideBarDef } from 'ag-grid-community';


import {
  Component,
  OnInit,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  HostBinding,
  HostListener,
  SimpleChanges,
} from '@angular/core';
import * as d3 from "d3";
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { RouterHandlerService } from 'src/app/services/router-handler.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ActivatedRoute, Router } from '@angular/router';

import { FilterService } from 'src/app/services/filter.service';
import { ManageStatusesDialogComponent, StatusConfig } from '../../manage-statuses-dialog/manage-statuses-dialog.component';
import { BetweenCondition, RuleSet, Rule } from '../../manage-statuses-dialog/manage-statuses-dialog.component';



// import patientJourneyData from './patient_journey_data_with_source_name.json_shortened.json';
// import patientJourneyData from '../../../../../../../../data/patient_journey_data_with_source_name.json_shortened.json'
import statusColors from './status_code_colors.json';

interface JourneyEvent {
  LH_PATIENT_ID: string;
  STATUS_DATE: string;
  STATUS_REASON_CODE: string;
  STATUS_REASON_CODE_DESC: string;
  JOURNEY_STOP: string;
  PATIENT_INITIATED_DATE: string;
  STATUS_GROUP: string;
  STATUS_SUB_GROUP: string;
  CURRENT_REFERRAL_STATUS: string;
  SP_DESCRIPTION?: string;
}

export interface PixelData extends JourneyEvent {
  rowIndex: number;
  colIndex: number; // Used for "Normal" view
  isConditionMet?: boolean;
  subDayIndex?: number;
  cx_standard?: number;
  cx_band_time?: number;
  cw_band_time?: number;
  cx_band_calendar?: number;
  cw_band_calendar?: number;
  cx_linear_time?: number;
  cx_linear_calendar?: number;
  // calendarSubDayIndex?: number;
  next_cx_linear_time?: number;
  next_cx_band_time?: number;
  next_cx_linear_calendar?: number;
  next_cx_band_calendar?: number;
}

export interface LegendStatusItem {
  code: string;
  desc: string;
  color: string;
  totalPoints: number;
  uniquePatients: number;
}

// interfaces we are going to feed to ManageStatusesDialogComponent 
export interface StatusReason {
  code: string;
  desc: string;
  checked: boolean;
  color: string;
}

export interface SubStatusGroup {
  name: string;
  checked: boolean;
  indeterminate: boolean;
  isExpanded: boolean;
  color: string;
  reasons: StatusReason[];
}

export interface StatusGroup {
  name: string;
  checked: boolean;
  indeterminate: boolean;
  isExpanded: boolean;
  color: string;
  subGroups: SubStatusGroup[];
}

export interface ReferralLayer {
  name: string; // e.g. "NURSING", "ACTIVE"
  checked: boolean;
  indeterminate: boolean;
  isExpanded: boolean;
  color: string; // Usually not colored directly, but good for UI consistency
  groups: StatusGroup[];
}

interface Cluster {
  pixels: PixelData[];    // The raw data points in this cluster
  worldX: number;         // The averaged world X-coordinate
  worldY: number;         // The averaged world Y-coordinate
  screenX: number;        // The cluster's screen X-coordinate (for hit detection)
  count: number;          // How many pixels are in it
  isCluster: boolean;     // Is count > 1?
}


const JOURNEY_STOP_COLORS = {
  'COMMERCIAL SPs': '#8859b6',     // Purple
  'Non-COMMERCIAL SPs': '#007bff', // Blue
  'HUB': '#f0b429',             // Yellow
};

// Define your fixed colors constant at the top of the file or inside the class
const FIXED_REFERRAL_COLORS: { [key: string]: string } = {
  'ACTIVE': '#28a745',        // Green
  'PENDING': '#ffc107',       // Yellow
  'CANCELLED': '#dc3545',     // Red
  'DISCONTINUED': '#8b0000',  // Dark Red
  // Add variants if your data uses slightly different naming
  // 'NURSING': '#28a745',       // Treat Nursing as Active/Green
  // 'ON HOLD': '#ffc107'        // Treat On Hold as Pending/Yellow
};

@Component({
  selector: 'app-pixel-map',
  templateUrl: './pixel-map.component.html',
  styleUrls: ['./pixel-map.component.scss']
})
export class PixelMapComponent implements OnInit, OnChanges {
  reqSubcription: Subscription[] = [];
  @ViewChild('pixelMapContainer', { static: true }) pixelMapContainer!: ElementRef
  @ViewChild('hideLinkCustomTooltip') hideLinkCustomTooltip!: ElementRef | any;
  
  @Input('data') data: any
  @Input('parentData') parentData: any
  @Input('pageKey') pageKey: any
  @Input('item') item: any
  @Input('type') type: any
  @Input('config') config: any
  @Input('headerConfig') headerConfig: any
  @Input('heading') heading: string = ''
  @Input('totalRecords') totalRecords: number = 0;
  @Input('error_name') error_name: any;


  @Input('dataStartIndex') dataStartIndex: number = 0;
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() filterQueryChange = new EventEmitter<string>(); // --- NEW OUTPUT ---
  @Output() serverSideSearch = new EventEmitter<string>(); // --- NEW OUTPUT ---

  @HostBinding('style.cursor') cursor = 'default';
  isActive = false;
  iconList: any[] = [];
  divId: any = "PixelMapDiv";
  noData: boolean = false;
  @Input() isLoading = false;

  public isLockedToVisible = false;

  @HostBinding('class.is-fullscreen') isFullscreen = false;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();

  private hostElement: HTMLElement;
  private allPixelData: PixelData[] = [];  // each individual status

  public currentView: 'standard' | 'calendar' | 'time' | 'table' = 'standard'; // Set default view
  private statusColorMap: { [key: string]: string } = {};

  private readonly worldWidth: number = 10000; // Fixed world width for linear scales
  private readonly subDayWorldOffset: number = 6; // World-space offset for same-day events

  private cellSize: number = 14; // Default, will be updated in initializeAllData
  private linearPixelSize: number = 6; // Default, will be updated in draw*View
  public paginationPageSize: number = 500;
  public currentPage: number = 0;
  public totalPages: number = 0;
  private patientJourneyMap: Map<string, JourneyEvent[]> = new Map(); // map of patient IDs to their array of statuses
  private patientIds: string[] = [];
  private allPatientIdsMaster: string[] = [];
  private lastScrollTop: number = 0;
  // properties for dynamic time-based layout
  private dailyMaxEvents = new Map<number, number>();
  private timeBasedLayout = {
    dayPositions: new Map<number, { x: number, width: number }>(),
    totalWidth: 0
  };
  private timeLayoutSorted: { day: number, x: number, width: number }[] = [];

  private calendarDateMaxEvents = new Map<string, number>(); // Key is 'YYYY-MM-DD' string
  private calendarLayout = {
    datePositions: new Map<string, { x: number, width: number }>(),
    totalWidth: 0
  };
  private calendarLayoutSorted: { dateKey: string, x: number, width: number }[] = [];

  private standardViewDataWidth: number = 0;
  private timeViewDataWidth: number = 0;
  private calendarViewDataWidth: number = 0;

  private dynamicHeight: number = 600; // Default initial height


  // For single click of status
  private selectedStatusCode: string | null = null;
  public highlightedNodesCount: number = 0;
  // For double click and status legend
  public legendItems: LegendStatusItem[] = [];
  public totalSelectedStatuses: number = 0;
  public totalPoints: number = 0;
  public totalUniquePatients: number = 0;

  // properties for managing hierarchial status data
  public statusHierarchy: ReferralLayer[] = [];
  public analyticalHierarchyState: ReferralLayer[] = []; // Temporary state for the dialog
  private reasonLookupMap = new Map<string, { color: string, reasonRef: StatusReason, subGroupRef: SubStatusGroup, parentGroupRef: StatusGroup }>();
  private analyticalReasonLookupMap = new Map<string, {
    color: string,
    reasonRef: StatusReason,
    subGroupRef: SubStatusGroup,
    parentGroupRef: StatusGroup,
    referralRef?: ReferralLayer
  }>();
  private readonly greyscaleColor = '#cccccc';
  public useAnalyticalMode = false;
  public extendBlocks = false;


  tooltipVisible: any;
  tooltipData: any;
  tooltipHeight: any;
  tooltipTurn: any;

  // CROSSHAIRS
  private hoverState: {
    uniqueId: string; // The point's unique ID (e.g., patientId-colIndex)
    screenX: number; // x-pos relative to main canvas
    screenY: number; // y-pos relative to main canvas
    patientId: string;
    xLabel: string;
    isCluster: boolean;
    hoveredData: PixelData[]; // All pixels in the cluster/point
  } | null = null;

  private crosshairSvg: d3.Selection<SVGSVGElement, unknown, null, undefined>;

  // Properties for double-click detection
  private lastClickTime: number = 0;
  private lastClickedNode: PixelData | null = null;
  private readonly doubleClickThreshold: number = 300; // ms for double-click

  // properties for dragging
  private isDragging: boolean = false;
  private dragStartNode: PixelData | null = null;

  private quadtree: any = null;
  private mainCanvas: HTMLCanvasElement | null = null;
  private pickingCanvas: HTMLCanvasElement | null = null;
  private highlightCanvas: HTMLCanvasElement | null = null;
  private margin = { top: 0, right: 40, bottom: 0, left: 60 };

  // Used for hover properties to your class
  private pickingMap: Map<string, PixelData> = new Map();
  private nextPickingId = 1; // Start at 1 (0 is for empty space)

  // for zooming logic
  private viewTransform = { x: 0, y: 0, kx: 1, ky: 1 }; // k = scale, x/y = translation
  private isPanning = false;
  private isCorrectingBrush = false; // Flag to prevent infinite loops in brush correction
  private lastPanPosition = { x: 0, y: 0 };
  private minZoom = 0.05; // Will be calculated dynamically
  private maxZoom = 20;   // Will be calculated dynamically
  // private readonly minKy: number = 0.8; // OLD: (constantPixelSize / rowHeight) -> 8 / 10 = 0.8.
  private minKy: number = 1.2; // NEW: (minScreenBoxSize + gap) / rowHeight -> (10 + 2) / 10 = 1.2
  private readonly initialKy: number = 1.8; // Target: 16px pixels + 2px gap -> (16 + 2) / 10 = 1.8
  /**
   * The desired *screen radius* for circles in 'standard' view.
   */
  private readonly constantPixelRadius: number = 4;
  /**
   * The desired *screen size* (width and height) for rectangles
   * in 'time' and 'calendar' views.
   */
  private readonly constantPixelSize: number = 8;
  private readonly screenBoxSize: number = 16; // New property for clustering box size
  private readonly rowHeight: number = 10; // World-space height of a row

  private animationTimer: d3.Timer | null = null;
  private animationState: {
    isRunning: boolean;
    t: number; // The eased interpolation factor (0 to 1)
    startIsLinear: boolean;
    endIsLinear: boolean;
    endX?: number;
    endY?: number;
    endK_x?: number; // Target Kx
    endK_y?: number; // Target Ky
  } = { isRunning: false, t: 0, startIsLinear: false, endIsLinear: false };

  // threshold and scales for the linear view
  // private readonly linearViewThreshold = 0.75; // Switch to linear view if zoomFactor is below this
  private readonly linearViewThreshold = 15; // Switch to linear view if zoomFactor is below this

  private readonly linearClusterThreshold = 15; // Screen pixel distance to group points into a cluster
  private timeScaleLinear: d3.ScaleLinear<number, number>;
  private dateScaleLinear: d3.ScaleUtc<number, number>;

  // Add these properties to your class, near the top
  public showPatientIDs: boolean = false;
  private patientIdsForPage: string[] = [];


  private mainCtx: CanvasRenderingContext2D | null = null;
  private pickingCtx: CanvasRenderingContext2D | null = null;
  private highlightCtx: CanvasRenderingContext2D | null = null;

  // Add this near your other data properties
  private masterPixelData: PixelData[] = [];


  // Properties for D3 Brush ---
  private xBrushSvg: d3.Selection<SVGSVGElement, unknown, null, undefined>;
  private brushX: d3.BrushBehavior<unknown>;
  private brushXScale: d3.ScaleLinear<number, number>;
  private lockedBrushXScale: d3.ScaleLinear<number, number> | null = null;
  private brushHeight = 50; // Total height for the brush area  
  private brushMargin = { top: 10, right: 40, bottom: 10, left: 60 }; // Match main margin
  private isBrushing = false; // To prevent event loops
  private dragStartIsLinear: boolean = false; // for dragging between scales
  private initChart: boolean = false; // (was missing from your properties)
  private selectedType: string = 'standard'; // (was missing from your properties)

  private yBrushSvg: d3.Selection<SVGSVGElement, unknown, null, undefined>;
  private yBrush: d3.BrushBehavior<unknown>;
  private yBrushScale: d3.ScaleLinear<number, number>;
  private yAxisWidth = 100; // Define as a constant property

  private headerSvg: d3.Selection<SVGSVGElement, unknown, null, undefined>;
  private headerHeight = 30;
  private currentRuleSet: RuleSet | null = null;
  private storedRuleSet: RuleSet | null = null;
  private readonly STORAGE_KEY = 'pixelMapQuery';
  private queryStatusCodes = new Set<string>();

  // --- NEW: Brush State Tracking for Constraints ---
  private lastXBrushSelection: [number, number] | null = null;
  private lastYBrushSelection: [number, number] | null = null;
  private isCorrectingBrush = false;
  private activeBrushHandle: 'start' | 'end' | 'center' | null = null;

  // Ag-Grid Properties
  public columnDefs: ColDef[] = [];
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
  };
  public rowData: any[] = [];
  public gridApi!: GridApi;
  public sideBar: SideBarDef | string | string[] | boolean | null = 'columns';

  private manageStatusesDialogRef: MatDialogRef<ManageStatusesDialogComponent> | null = null;

  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    // This listener detects *any* change in fullscreen state.
    // We check the actual state to determine if we just exited.
    if (!document.fullscreenElement) {
      this.closeFullscreen();
    }
  }

  constructor(
    private cdr: ChangeDetectorRef,
    public filterService: FilterService,
    public dialog: MatDialog, // Inject MatDialog
    private route: ActivatedRoute,
    private routerHandlerService: RouterHandlerService,
    private navigationService: NavigationService
  ) {
    this.filterService.changeDisplays.subscribe((res: any) => {
      // gets the value of the selected toggle from the icon chart 
      this.changeDisplayType(res);
    });

    // starts the fetch for our data
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.start()
        // this.getcommentsData()
      })
    )

    // This is used for setting up the route to the pixel map
    this.route.params.subscribe((p: any) => {
      this.queryParams = p;
      this.moduleName = p['module'] || '';

      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });
  }

  public goToPatientList(event): void {
    console.log("arrow clicked");

    if (!this.item.config?.['nav_configuration']) {
      console.warn("Navigation configuration missing");
      return;
    }

    // Start with the other charts' filters
    let combinedPayload: any = {};
    
    // // Merge filters from other charts
    // this.otherChartFilters.forEach((value, key) => {
    //     combinedPayload[key] = value;
    // });

    // Add current chart's selection if any
    // if (this.selectedRibbons.size > 0) {
    //     // Pass the selected keys directly
    //     const currentKeys = Array.from(this.selectedRibbons).join(',');
    //     const myKey = this.item.config?.sub_cat_key || 'pat_seq_sub_cat_key';
    //     combinedPayload[myKey] = currentKeys;
    // }
    
    // Only navigate if we have something to send? 
    // Or allow navigation even if empty (maybe passing empty object)?
    // Original code checked `if (this.selectedRibbons.size > 0)`.
    // Now we should check if `combinedPayload` has any keys.
    
    // if (Object.keys(combinedPayload).length > 0) {
        this.NavigationArrow('chart', combinedPayload, event.offsetX, event.offsetY, 500)
    // }
  }

  private NavigationArrow(myType: any, myData: any, myX: any, myY: any, chartWidth: any): void {
    // Navigation taken from horizontal-bar-chart.component.ts
    const conf0 = this.item.config?.['nav_configuration'].controls[0]
    let nav = {
      dbJSON: conf0.dbJSON,
      s3JSON: conf0.s3JSON,
      pageName: conf0.pageName,
      isDashboardLevel: conf0.isDashboardLevel
    }

    // let payload:any ={[conf0.payloadData]:conf0.payloadData=='column_key'? myData[0].AllData[0][conf0.payloadData] : myData[0].range }
    
    let payload;
    // Check if myData is already a payload object (not an array)
    if (typeof myData === 'object' && !Array.isArray(myData) && myData !== null) {
        // It's already the map of keys
        payload = myData;
        // Also ensure current chart's default key is present if needed? 
        // It should be in the map already from goToPixelMap logic.
    } else {
        // Legacy fallback
        payload = { [conf0?.payloadData]: Array.isArray(myData) ? myData.join(',') : myData };
    }
    
    this.routerHandlerService.navDetailInfo(nav);
    this.routerHandlerService.storingPayloadAndFilterForGrid(conf0, payload, '');

    let query: any = Object.assign({}, this.decryptedParams, { tab_id: 0 }, { page: 'card' });
    let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
    this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${nav.pageName}`, queryMaped);
  }

  public fullscreenChanges(wantFullscreen: boolean) {
    const elem = this.hostElement; // Or document.documentElement for entire page

    if (wantFullscreen) {
      // Request Native Fullscreen
      if (elem.requestFullscreen) {
        elem.requestFullscreen().catch((err: any) => {
          console.error(`Error attempting to enable fullscreen: ${err.message}`);
        });
      }
    } else {
      // Exit Native Fullscreen
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
    // No need to call plotChart() or calculate height here. 
    // The 'fullscreenchange' event will fire and trigger handleFullscreenChange().
  }

  closeFullscreen(): void {
    // Exit fullscreen: Recalculate dynamic height based on data
    this.isFullscreen = false;
    if (document.fullscreenElement) {
      document.exitFullscreen(); // Ensure native exit if needed
    }
    // Recalculate height based on data when exiting fullscreen
    // this.dynamicHeight = this.calculateDynamicHeight();
    this.props = { chartHeight: this.dynamicHeight }; // Update props object
    this.isActive = false;
    setTimeout(() => {
      this.renderMain();
    }, 100);
  }

  start() { this.isLoading = true; }

  ngOnInit(): void {
    let cfg = this.item.config;
    this.paginationPageSize = cfg["default_pagenation"] || 500;
    // This function now only does the one-time setup
    this.hostElement = this.pixelMapContainer.nativeElement;
    // 1. Load stored query state (but do not apply it yet)
    const storedQuery = localStorage.getItem(this.STORAGE_KEY);
    if (storedQuery) {
      try {
        this.storedRuleSet = JSON.parse(storedQuery);
        console.log('Loaded stored query:', this.storedRuleSet);
      } catch (e) {
        console.error('Failed to parse stored query:', e);
      }
    }
    this.start();
    this.initiateCharts();
  }

  ngAfterViewInit(): void {
    // --- ONE-TIME CANVAS SETUP ---
    // Remove any previous D3-generated containers
    d3.select(this.hostElement).select('.chart-container').remove();

    // Calculate initial height based on current state (with fullscreen consideration)
    const initialHeight = this.updateChartHeight();

    const setHeight = 500;
    // Ensure item config exists and update it for PivotGrid
    if (this.item) {
      if (!this.item.config) {
        this.item.config = {};
      }
      this.item.config.chartHeight = setHeight;
    }


    const container = d3.select(this.hostElement)
      .append('div')
      .attr('class', 'chart-container')
      .style('position', 'relative') // Needed for absolute positioning of canvases
      .style('height', `${initialHeight}px`)
      .style('min-height', `${setHeight}px`)
      .style('overflow', 'hidden'); // The container itself doesn't scroll

    // Add Brush SVG ---
    this.xBrushSvg = container.insert('svg', ':first-child') // Insert as the first child
      .attr('class', 'brush-svg')
      .style('position', 'absolute')
      .style('top', '0')
      .style('left', '0')
      .style('width', '100%')
      .style('height', `${this.brushHeight}px`)
      .style('z-index', '10'); // Make sure it's above canvases

    this.yBrushSvg = container.append('svg')
      .attr('class', 'y-brush-svg')
      .style('position', 'absolute')
      .style('top', `${this.brushHeight}px`) // Position below top brush
      .style('left', '0')
      .style('width', `${this.yAxisWidth}px`)
      .style('height', `calc(100% - ${this.brushHeight}px)`) // Fill remaining height
      .style('z-index', '10');

    // --- NEW: Add group for hover label ---
    this.yBrushSvg.append('g')
      .attr('class', 'hover-y-label')
      .style('pointer-events', 'none'); // So it doesn't block brushing

    // --- NEW: Create the Header SVG ---
    this.headerSvg = container.append('svg')
      .attr('class', 'header-svg')
      .style('position', 'absolute')
      .style('top', `${this.brushHeight}px`) // Position below the top brush
      .style('left', `${this.yAxisWidth}px`) // Position right of the Y brush
      .style('height', `${this.headerHeight}px`) // Set its specific height
      .style('width', `calc(100% - ${this.yAxisWidth}px)`) // Fill remaining width
      .style('z-index', '5'); // Below brushes, above main canvas

    // --- NEW: Add a group for the header labels ---
    this.headerSvg.append('g')
      .attr('class', 'header-labels');

    // --- NEW: Add group for hover label ---
    this.headerSvg.append('g')
      .attr('class', 'hover-x-label')
      .style('pointer-events', 'none'); // So it doesn't block brushing
    // add in code for Crosshairs
    this.crosshairSvg = container.append('svg')
      .attr('class', 'crosshair-svg')
      .style('position', 'absolute')
      .style('top', `${this.brushHeight + this.headerHeight}px`)
      .style('left', `${this.yAxisWidth}px`)
      .style('pointer-events', 'none') // Crucial: let mouse events pass through to canvas
      .style('z-index', '30'); // On top of everything

    // Add the two lines immediately, hidden by default
    this.crosshairSvg.append('line')
      .attr('class', 'crosshair-x')
      .style('stroke', '#333')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '4,2')
      .style('opacity', 0.8)
      .style('visibility', 'hidden');

    this.crosshairSvg.append('line')
      .attr('class', 'crosshair-y')
      .style('stroke', '#333')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '4,2')
      .style('opacity', 0.8)
      .style('visibility', 'hidden');

    this.mainCanvas = container.append('canvas').attr('class', 'main-canvas').node();
    this.pickingCanvas = container.append('canvas').attr('class', 'picking-canvas').node();
    this.highlightCanvas = container.append('canvas').attr('class', 'highlight-canvas').node();

    // Style the canvases
    [this.mainCanvas, this.pickingCanvas, this.highlightCanvas].forEach(canvas => {
      d3.select(canvas)
        .style('position', 'absolute')
        // Position below BOTH the top brush AND the new header SVG
        .style('top', `${this.brushHeight + this.headerHeight}px`)
        .style('left', `${this.yAxisWidth}px`);
    });
    d3.select(this.mainCanvas).style('z-index', '20'); // Data is behind crosshairs
    d3.select(this.pickingCanvas).style('pointer-events', 'none');
    d3.select(this.highlightCanvas)
      .style('z-index', '35') // Highlight is on top of crosshairs (30)
      .style('pointer-events', 'none'); // Let clicks pass through

    // Get contexts
    this.mainCtx = this.mainCanvas.getContext('2d');
    this.pickingCtx = this.pickingCanvas.getContext('2d');
    this.highlightCtx = this.highlightCanvas.getContext('2d');

    // --- NEW: Initialize Brushes ---
    this.setupBrush('x'); // X-axis brush
    this.setupBrush('y'); // Y-axis brush

    // --- ONE-TIME EVENT LISTENER SETUP ---
    this.mainCanvas.addEventListener('mousedown', this.onCanvasMouseDown.bind(this));
    this.mainCanvas.addEventListener('mousemove', this.onCanvasMouseMove.bind(this));
    this.mainCanvas.addEventListener('mouseup', this.onCanvasMouseUp.bind(this));
    this.mainCanvas.addEventListener('mouseleave', this.onCanvasMouseLeave.bind(this));

    this.mainCanvas.addEventListener("wheel", (e) => {
      e.preventDefault();
      const isMac = navigator.platform.toUpperCase().includes('MAC');
      const isCtrlOrCmd = isMac ? e.metaKey : e.ctrlKey;

      if (isCtrlOrCmd) { // Zooming logic
        // --- MODIFIED: Use kx as the base for new scale ---
        const newScale = this.viewTransform.kx * (e.deltaY < 0 ? 1.1 : 0.9);
        this.applyZoom(newScale, { x: e.offsetX, y: e.offsetY });
      } else { // Panning logic
        const deltaX = e.deltaX !== 0 ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
        const deltaY = e.deltaX !== 0 ? 0 : (e.shiftKey ? 0 : e.deltaY);

        this.viewTransform.x -= deltaX;
        this.viewTransform.y -= deltaY;

        this.clampTransform();
        this.renderMain();
      }
    }, { passive: false });
    // Listen for native fullscreen changes (handles ESC key and API calls)
    document.addEventListener('fullscreenchange', this.handleFullscreenChange.bind(this));

    // (Optional) Listen for standard window resizing
    window.addEventListener('resize', () => {
      if (!this.isFullscreen) {
        this.handleFullscreenChange();
      }
    });

  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }

  public handleFullscreenChange(): void {
    // 1. Check standard browser APIs to see if we are actually in fullscreen
    this.isFullscreen = !!document.fullscreenElement;
    this.isActive = this.isFullscreen; // Sync your active state

    // 2. Update the container size
    this.updateChartHeight();

    // 3. Update Canvas resolution (DPI scaling)
    this.updateCanvasSizes();

    // 4. Redraw the canvas content (Fast redraw, not full re-process)
    // Using a small timeout allows the browser to finish the layout transition
    setTimeout(() => {
      this.renderMain();
    }, 50);
  }

  private updateChartHeight(): void {
    const containerNodes = this.hostElement.querySelectorAll('.chart-container');
    if (!containerNodes.length) return;

    let newHeight: number;

    if (this.isFullscreen) {
      // FULLSCREEN MODE
      // Use innerHeight to get the exact viewport height available
      // Subtracting 0 or a small buffer if you have a floating header
      newHeight = window.innerHeight;
    } else {
      // STANDARD MODE
      // Use your existing logic to fit within the parent container
      newHeight = this.calculateAvailableHeight();
    }

    // Update Class Properties
    this.dynamicHeight = newHeight;
    console.log('[PixelMap] Updating height to:', newHeight);
    if (this.props) {
      this.props.chartHeight = newHeight;
    }

    // Ensure item config exists and update it for PivotGrid
    if (this.item) {
      if (!this.item.config) {
        this.item.config = {};
      }
      this.item.config.chartHeight = newHeight;
    }

    // Apply to DOM
    containerNodes.forEach(node => {
      (node as HTMLElement).style.height = `${newHeight}px`;
    });
  }

  // Add this helper method to update canvas sizes based on new container dimensions
  private updateCanvasSizes(): void {
    const containerNode = this.hostElement.querySelector('.chart-container') as HTMLElement;
    if (!containerNode || !this.mainCanvas) return;

    const dpr = window.devicePixelRatio || 1;
    const yAxisLabelWidth = this.showPatientIDs ? this.yAxisWidth : 0;
    const mainViewportWidth = containerNode.clientWidth - yAxisLabelWidth;
    const viewportHeight = containerNode.clientHeight - this.brushHeight - this.headerHeight;

    [this.mainCanvas, this.pickingCanvas, this.highlightCanvas].forEach(canvas => {
      canvas.width = mainViewportWidth * dpr;
      canvas.height = viewportHeight * dpr;
      canvas.style.width = `${mainViewportWidth}px`;
      canvas.style.height = `${viewportHeight}px`;
    });

    // Update crosshair SVG dimensions
    if (this.crosshairSvg) {
      this.crosshairSvg
        .attr('width', mainViewportWidth)
        .attr('height', viewportHeight);
    }
  }

  private calculateAvailableHeight(): number {
    // We are in "Normal" mode here.
    // Calculate space based on window height minus the top offset of the chart
    const viewportHeight = window.innerHeight;
    const hostRect = this.hostElement.getBoundingClientRect();
    const topOffset = hostRect.top;

    // Buffer to prevent scrollbars (padding/margins)
    const bottomBuffer = 40;
    const minHeight = 500;

    // Calculate remaining vertical space
    const calculated = viewportHeight - topOffset - bottomBuffer;

    return Math.max(calculated, minHeight);
  }

  // --- NEW: Brush Setup Function ---
  private setupBrush(axis: 'x' | 'y'): void {
    const isX = axis === 'x';
    const svg = isX ? this.xBrushSvg : this.yBrushSvg;

    if (!svg) return;

    const padding = 10;

    if (isX) {
      const brushContainerWidth = this.pixelMapContainer.nativeElement.clientWidth;
      const brushPixelWidth = brushContainerWidth - this.margin.left - this.margin.right;
      const brushPixelLeft = padding;
      const brushPixelRight = brushPixelWidth - padding;
      const brushPixelHeight = this.brushHeight - this.brushMargin.top - this.brushMargin.bottom;

      this.brushXScale = d3.scaleLinear().range([brushPixelLeft, brushPixelRight]);

      this.brushX = d3.brushX()
        .extent([[brushPixelLeft, 0], [brushPixelRight, brushPixelHeight]])
        .on('start', (event) => this.onBrushStart(event, 'x'))
        .on('brush', (event) => {
          this.onBrushMove(event, 'x');
        })
        .on('end', (event) => this.onBrushEnd(event, 'x'));

      const brushGroup = svg.append('g')
        .attr('class', 'brush')
        .attr('transform', `translate(${this.margin.left}, ${this.brushMargin.top})`)
        .call(this.brushX);

      // 1. Style the native selection (blue box)
      brushGroup.select('.selection')
        .attr('fill', '#4a90e2')
        .attr('fill-opacity', 0.3)
        .attr('stroke', '#4a90e2')
        .attr('stroke-width', '1px')
        .attr('rx', 3)
        .attr('ry', 3);

      // 2. Remove styling from native handles (keep them invisible but interactive)
      brushGroup.selectAll('.handle')
        .style('opacity', 0);

      // 3. Create our custom centered handles
      this.createCustomHandles(brushGroup, 'x', brushPixelHeight);

    } else {
      const yBrushContainerHeight = this.pixelMapContainer.nativeElement.clientHeight - this.brushHeight;
      const brushPixelTop = padding;
      const brushPixelBottom = yBrushContainerHeight - padding;
      const brushHandleWidth = 24;

      this.yBrushScale = d3.scaleLinear().range([brushPixelTop, brushPixelBottom]);

      this.yBrush = d3.brushY()
        .extent([[0, brushPixelTop], [brushHandleWidth, brushPixelBottom]])
        .on('start', (event) => this.onBrushStart(event, 'y'))
        .on('brush', (event) => {
          this.onBrushMove(event, 'y');
        })
        .on('end', (event) => this.onBrushEnd(event, 'y'));

      const brushXOffset = 5;

      const brushGroup = svg.insert('g', ':first-child')
        .attr('class', 'y-brush')
        .attr('transform', `translate(${brushXOffset}, 0)`)
        .call(this.yBrush);

      // 1. Style Selection
      brushGroup.select('.selection')
        .attr('fill', '#4a90e2')
        .attr('fill-opacity', 0.3)
        .attr('stroke', '#4a90e2')
        .attr('stroke-width', '1px')
        .attr('rx', 3)
        .attr('ry', 3);

      // 2. Hide native handles
      brushGroup.selectAll('.handle').style('opacity', 0);

      // 3. Create custom handles
      this.createCustomHandles(brushGroup, 'y', brushHandleWidth);

      svg.append('g').attr('class', 'y-axis-labels');
    }
  }

  // --- NEW HELPER: Create Custom Visual Handles ---
  private createCustomHandles(brushGroup: any, axis: 'x' | 'y', crossSize: number) {
    const handleWidth = axis === 'x' ? 12 : 24;
    const handleHeight = axis === 'x' ? 24 : 12;

    // For X axis: Centered vertically. For Y axis: Centered horizontally.
    const yOffset = axis === 'x' ? (crossSize - handleHeight) / 2 : 0;
    const xOffset = axis === 'y' ? (crossSize - handleWidth) / 2 : 0;

    // We create two groups: one for start, one for end
    const handles = brushGroup.selectAll('.custom-handle')
      .data([{ type: 'start' }, { type: 'end' }])
      .enter()
      .append('g')
      .attr('class', (d: any) => `custom-handle custom-handle-${d.type}`)
      .style('pointer-events', 'none'); // Let clicks pass through to the real hidden brush handles

    // Append the White Pill Rect
    handles.append('rect')
      .attr('width', handleWidth)
      .attr('height', handleHeight)
      .attr('x', axis === 'x' ? -handleWidth / 2 : xOffset) // Centered on X
      .attr('y', axis === 'y' ? -handleHeight / 2 : yOffset) // Centered on Y
      .attr('rx', 3)
      .attr('ry', 3)
      .style('fill', 'white')
      .style('stroke', '#d0d0d0')
      .style('stroke-width', '2px');

    // Append the Grip Line
    if (axis === 'x') {
      handles.append('line')
        .attr('x1', 0) // 0 is the center of the group
        .attr('x2', 0)
        .attr('y1', yOffset + 6)
        .attr('y2', yOffset + handleHeight - 6)
        .style('stroke', '#999')
        .style('stroke-width', '1.5px');
    } else {
      handles.append('line')
        .attr('x1', xOffset + 6)
        .attr('x2', xOffset + handleWidth - 6)
        .attr('y1', 0) // 0 is center of group
        .attr('y2', 0)
        .style('stroke', '#999')
        .style('stroke-width', '1.5px');
    }
  }

  // --- NEW HELPER: Update Positions ---
  private updateHandlePositions(brushGroup: any, selection: [number, number] | null, axis: 'x' | 'y') {
    if (!selection) {
      brushGroup.selectAll('.custom-handle').style('display', 'none');
      return;
    }

    brushGroup.selectAll('.custom-handle').style('display', null);
    const [start, end] = selection;

    if (axis === 'x') {
      brushGroup.select('.custom-handle-start').attr('transform', `translate(${start}, 0)`);
      brushGroup.select('.custom-handle-end').attr('transform', `translate(${end}, 0)`);
    } else {
      brushGroup.select('.custom-handle-start').attr('transform', `translate(0, ${start})`);
      brushGroup.select('.custom-handle-end').attr('transform', `translate(0, ${end})`);
    }
  }

  // --- NEW: Brush Start Handler ---
  private onBrushStart(event: any, axis: 'x' | 'y'): void {
    if (!event.sourceEvent) return;
    this.isBrushing = true;
    
    // Identify which handle is being dragged
    const target = event.sourceEvent.target;
    // D3 brush handles usually have class 'handle handle--w' (start) or 'handle handle--e' (end) for X
    // For Y: 'handle handle--n' (start) or 'handle handle--s' (end)
    // Or our custom handles might be capturing it? No, custom handles have pointer-events: none.
    
    if (axis === 'x') {
       if (target.classList.contains('handle--w')) this.activeBrushHandle = 'start';
       else if (target.classList.contains('handle--e')) this.activeBrushHandle = 'end';
       else this.activeBrushHandle = 'center';
       
       this.lockedBrushXScale = this.brushXScale.copy();
       this.dragStartIsLinear = this.viewTransform.kx < this.linearViewThreshold;
       this.lastXBrushSelection = event.selection;
    } else {
       if (target.classList.contains('handle--n')) this.activeBrushHandle = 'start';
       else if (target.classList.contains('handle--s')) this.activeBrushHandle = 'end';
       else this.activeBrushHandle = 'center';

       this.lastYBrushSelection = event.selection;
    }
  }

  // --- Main working function for brushes ---
  private onBrushMove(event: any, axis: 'x' | 'y'): void {
    // Guards:
    // 1. Must be user-initiated (sourceEvent exists) OR we are self-correcting.
    // 2. Must have a selection.
    if (!event.sourceEvent && !this.isCorrectingBrush) return; 

    const selection = event.selection;
    if (!selection) return;

    // --- FIX: Strict minimum gap enforcement (Hard Stop) ---
    // This physically stops the handles from overlapping during drag.
    const gap = 20;
    const currentWidth = selection[1] - selection[0];
    const lastSelection = axis === 'x' ? this.lastXBrushSelection : this.lastYBrushSelection;

    // We check BOTH gap AND crossing (if handles flip)
    // Actually, D3 automatically flips selection so start < end.
    // If we cross, 'start' becomes the old 'end' (roughly).
    
    if (currentWidth < gap) {
       let newStart = selection[0];
       let newEnd = selection[1];

       // Use active handle to enforce logic against the stationary one
       if (lastSelection && this.activeBrushHandle) {
         const [lastStart, lastEnd] = lastSelection;
         
         if (this.activeBrushHandle === 'start') {
           // Dragging left handle. It hit the right handle.
           // Limit: Must be at least gap from lastEnd
           // Force it to be exactly (lastEnd - gap)
           newStart = lastEnd - gap;
           newEnd = lastEnd;
         } else if (this.activeBrushHandle === 'end') {
           // Dragging right handle. It hit the left handle.
           // Limit: Must be at least gap from lastStart
           newEnd = lastStart + gap;
           newStart = lastStart;
         } else {
           // Dragging center (panning). Keep fixed width.
           // Or if we can't tell, use center fallback.
            const center = (selection[0] + selection[1]) / 2;
            newStart = center - gap / 2;
            newEnd = center + gap / 2;
         }
       } else {
          // Fallback if no history
          const center = (selection[0] + selection[1]) / 2;
          newStart = center - gap / 2;
          newEnd = center + gap / 2;
       }
       
       // Apply Hard Stop
       const brush = axis === 'x' ? this.brushX : this.yBrush;
       const brushGroup = axis === 'x' 
        ? this.xBrushSvg.select('g.brush') 
        : this.yBrushSvg.select('g.y-brush');

       if (brush && brushGroup) {
          this.isCorrectingBrush = true;
          // IMPORTANT: Check if we are really changing something to avoid infinite loop potential
          // though isCorrectingBrush handles that.
          
          brushGroup.call(brush.move, [newStart, newEnd]);
          this.isCorrectingBrush = false;
          
          this.updateHandlePositions(brushGroup, [newStart, newEnd], axis);
       }
       return; // Stop processing
    }
    
    // Valid Frame: Update state and proceed to Zoom logic
    if (axis === 'x') {
       this.lastXBrushSelection = selection;
    } else {
       this.lastYBrushSelection = selection;
    }
    
    // --- FIX: Ensure handles are updated to the VALID selection ---
    // We update here because the recursive call above handles the INVALID case.
    // This handles the normal valid drag case.
    const brushGroup = axis === 'x' 
        ? this.xBrushSvg.select('g.brush') 
        : this.yBrushSvg.select('g.y-brush');
    this.updateHandlePositions(brushGroup, selection, axis);

    if (axis === 'x') {
      // --- 1. Capture START state (only if no animation is running) ---
      if (!this.animationTimer) {
        this.animationState.startX = this.viewTransform.x;
        this.animationState.startY = this.viewTransform.y;
        this.animationState.startKx = this.viewTransform.kx;
        this.animationState.startKy = this.viewTransform.ky;
        this.animationState.startIsLinear = this.viewTransform.kx < this.linearViewThreshold;
      }
      const oldIsLinear = this.dragStartIsLinear;

      // --- 2. Calculate NEW target ---
      // --- Use the locked scale for the *entire* drag ---
      const scaleToUse = this.lockedBrushXScale || this.brushXScale;
      const [dataStart, dataEnd] = selection.map(scaleToUse.invert);

      const dataWidth = dataEnd - dataStart;
      if (dataWidth <= 0) return;

      const yAxisWidth = this.showPatientIDs ? this.yAxisWidth : 0;
      const mainCanvasWidth = this.mainCanvas.clientWidth - yAxisWidth;

      const newKx = mainCanvasWidth / dataWidth;
      let targetKx = Math.max(this.minZoom, Math.min(newKx, this.maxZoom));
      let targetX = -dataStart * targetKx;
      let targetY = this.animationState.startY; // Y does not change
      let targetKy = this.animationState.startKy; // Y does not change

      const newIsLinear = targetKx < this.linearViewThreshold;
      const thresholdCrossed = oldIsLinear !== newIsLinear && (this.currentView === 'time' || this.currentView === 'calendar');

      // --- 3. ANCHORING CORRECTION (anchored to center) ---
      if (thresholdCrossed) {
        const screen_anchor_x = mainCanvasWidth / 2;
        const worldX_start = (screen_anchor_x - this.animationState.startX) / this.animationState.startKx;
        let worldX_end;

        const bisector = d3.bisector((d: any) => d.x).left;
        if (this.currentView === 'time' && this.timeScaleLinear) {
          if (oldIsLinear) { // linear -> band
            const dataValue_Day = this.timeScaleLinear.invert(worldX_start);
            const day = Math.floor(dataValue_Day);
            const subDayFraction = dataValue_Day - day;
            const bandLayout = this.timeBasedLayout.dayPositions.get(day);
            if (bandLayout) {
              worldX_end = bandLayout.x + (subDayFraction * bandLayout.width);
            }
          } else { // band -> linear
            const index = bisector(this.timeLayoutSorted, worldX_start);
            // --- FIX: Handle index 0 ---
            const foundLayout = index === 0 ? this.timeLayoutSorted[0] : this.timeLayoutSorted[index - 1];
            let day, subDayFraction = 0;
            if (foundLayout) {
              day = foundLayout.day;
              subDayFraction = foundLayout.width > 0 ? (worldX_start - foundLayout.x) / foundLayout.width : 0;
              subDayFraction = Math.max(0, Math.min(1, subDayFraction));
            }
            if (day !== undefined) {
              worldX_end = this.timeScaleLinear(day + subDayFraction);
            }
          }
        } else if (this.currentView === 'calendar' && this.dateScaleLinear) {
          const toDateKey = d3.timeFormat("%Y-%m-%d");
          if (oldIsLinear) { // linear -> band
            const dataValue_Date = this.dateScaleLinear.invert(worldX_start);
            const dateKey = toDateKey(dataValue_Date);
            const dayStart = d3.timeDay.floor(dataValue_Date);
            const subDayFraction = (dataValue_Date.getTime() - dayStart.getTime()) / (1000 * 60 * 60 * 24);
            const bandLayout = this.calendarLayout.datePositions.get(dateKey);
            if (bandLayout) {
              worldX_end = bandLayout.x + (subDayFraction * bandLayout.width);
            }
          } else { // band -> linear
            const index = bisector(this.calendarLayoutSorted, worldX_start);
            // --- FIX: Handle index 0 ---
            const foundLayout = index === 0 ? this.calendarLayoutSorted[0] : this.calendarLayoutSorted[index - 1];
            let dateKey, subDayFraction = 0;
            if (foundLayout) {
              dateKey = foundLayout.dateKey;
              subDayFraction = foundLayout.width > 0 ? (worldX_start - foundLayout.x) / foundLayout.width : 0;
              subDayFraction = Math.max(0, Math.min(1, subDayFraction));
            }
            if (dateKey) {
              const dayStart = new Date(dateKey).getTime();
              worldX_end = this.dateScaleLinear(new Date(dayStart + (subDayFraction * (1000 * 60 * 60 * 24))));
            }
          }
        }

        if (worldX_end === undefined) worldX_end = worldX_start;

        const worldShiftX = worldX_end - worldX_start;
        targetX -= (worldShiftX * targetKx);
      }

      // --- 4. Update animation state ---
      this.animationState.endX = targetX;
      this.animationState.endY = targetY;
      this.animationState.endK_x = targetKx;
      this.animationState.endK_y = targetKy;
      this.animationState.endIsLinear = newIsLinear;
      this.animationState.duration = thresholdCrossed ? 600 : 100;

      // --- 5. Start timer (if not already running) ---
      if (!this.animationTimer) {
        // (The timer logic is identical to applyZoom, but interpolates X only)
        this.animationTimer = d3.timer(elapsed => {
          const duration = this.animationState.duration || 100;
          const t = Math.min(1, elapsed / duration);
          const easedT = d3.easeCubicOut(t);

          if (this.animationState.startIsLinear !== this.animationState.endIsLinear) {
            this.animationState.isRunning = true;
            this.animationState.t = easedT;
          }

          // Interpolate X
          this.viewTransform.x = d3.interpolate(this.animationState.startX, this.animationState.endX)(easedT);
          this.viewTransform.kx = d3.interpolate(this.animationState.startKx, this.animationState.endK_x)(easedT);
          // Y is fixed
          this.viewTransform.y = this.animationState.startY;
          this.viewTransform.ky = this.animationState.startKy;

          this.clampTransform();
          this.renderMain();

          if (t === 1) {
            this.animationTimer.stop();
            this.animationTimer = null;
            this.animationState.isRunning = false;
            // Clear start state
            this.animationState.startX = undefined;
          }
        });
      }
    } else {
      // Y Logic
      const headerHeight = this.currentView === 'standard' ? 0 : 30;
      const mainCanvasHeight = this.mainCanvas.clientHeight - headerHeight;
      const [y0_raw, y1_raw] = selection;

      // --- NEW: Clamp Brush Size to Zoom Constraints ---
      // We need to ensure the brush size doesn't correspond to a zoom > maxZoom or < minKy
      // newKy = mainCanvasHeight / dataHeight
      // dataHeight = (y1 - y0) mapped to domain
      // changing y1-y0 changes dataHeight.
      //
      // let H_brush = y1 - y0
      // let H_total = brushTrackHeight (range[1] - range[0])
      // dataHeight = TotalDataDomain * (H_brush / H_total)
      // newKy = mainCanvasHeight / (TotalDataDomain * (H_brush / H_total))
      // newKy = (mainCanvasHeight * H_total) / (TotalDataDomain * H_brush)
      //
      // So:
      // H_brush = (mainCanvasHeight * H_total) / (TotalDataDomain * newKy)
      //
      // Min H_brush (for maxZoom): newKy = maxZoom
      // Max H_brush (for minKy):   newKy = minKy

      const brushRange = this.yBrushScale.range();
      const brushTrackHeight = brushRange[1] - brushRange[0];
      const domain = this.yBrushScale.domain();
      const totalDataDomain = domain[1] - domain[0];

      // Calculate allowed pixel heights
      // Avoid division by zero
      const safeTotalData = totalDataDomain || 1;
      
      const minBrushSize = (mainCanvasHeight * brushTrackHeight) / (safeTotalData * this.maxZoom);
      const maxBrushSize = (mainCanvasHeight * brushTrackHeight) / (safeTotalData * this.minKy);

      let y0 = y0_raw;
      let y1 = y1_raw;
      let currentSize = y1 - y0;

      // Check if we are violating limits
      if (currentSize < minBrushSize || currentSize > maxBrushSize) {
         // Determine interaction type (resize from top, bottom, or move) based on previous state if available,
         // but D3 doesn't give us the "handle" easily here without storing state.
         // A simple approach: clamp the size, centered on the current selection, OR respect the moving edge.
         // Better for UX: If dragging one handle, stop THAT handle.
         // However, identifying which handle is hard.
         // Simple reliable fix: Clamp width, keeping the center, or just clamp y1 if both move?
         
         const clampedSize = Math.max(minBrushSize, Math.min(currentSize, maxBrushSize));
         const center = (y0 + y1) / 2;
         y0 = center - clampedSize / 2;
         y1 = center + clampedSize / 2;

         // Ensure we stay within track bounds
         if (y0 < brushRange[0]) { y0 = brushRange[0]; y1 = y0 + clampedSize; }
         if (y1 > brushRange[1]) { y1 = brushRange[1]; y0 = y1 - clampedSize; }

         // Re-apply to brush to force the UI to stop (Visual Hard Stop)
         // We must use a timeout or check if we are already correcting to avoid loops if we were using 'end' event,
         // but 'brush' event is fine if we are careful.
         if (Math.abs(currentSize - clampedSize) > 0.01) {
             const brushGroup = this.yBrushSvg.select<SVGGElement>('g.y-brush');
             // Temporarily disable listening to avoid infinite loop? 
             // D3 brush emits event on programmatic move.
             // We can use a flag.
             if (!this.isCorrectingBrush) {
                 this.isCorrectingBrush = true;
                 brushGroup.call(this.yBrush.move, [y0, y1]);
                 this.isCorrectingBrush = false;
                 return; // Return early, the new move event will trigger the logic again with correct values
             }
         }
      }

      const dataStart = this.yBrushScale.invert(y0);
      const dataEnd = this.yBrushScale.invert(y1);
      const dataHeight = dataEnd - dataStart;

      if (dataHeight <= 0) return;

      const newKy = mainCanvasHeight / dataHeight;
      const newY = -dataStart * newKy;

      this.viewTransform.ky = Math.max(this.minKy, Math.min(newKy, this.maxZoom));
      this.viewTransform.y = newY; // y is tied to y0, implicitly clamped by brush position

      this.clampTransform();
      this.renderMain();
    }
  }

  // --- MODIFIED: This is the new, simpler 'end' handler ---
  private onBrushEnd(event: any, axis: 'x' | 'y'): void {
    this.isBrushing = false; // Clear flag

    if (axis === 'x') {
      this.lockedBrushXScale = null; // Clear the snapshot
      // Added '&& event.sourceEvent' to break the loop ---
      // This ensures we only reset zoom if the USER cleared the brush,
      // not if our code did (like in resetZoom).
      if (!event.selection && event.sourceEvent) {
        this.resetZoom();
      }
    } else {
      if (!event.selection && event.sourceEvent) {
        // If brush is cleared, reset only the Y-axis zoom/pan
        this.viewTransform.y = 0;
        this.viewTransform.ky = this.viewTransform.kx; // Or reset to 1
        this.clampTransform();
        this.renderMain();
      }
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    // this.gridApi.sizeColumnsToFit();
  }

  // --- NEW: Helper to update brush from chart state ---
  private updateBrushFromTransform(axis: 'x' | 'y'): void {
    if (this.isBrushing) { return; } // <-- MODIFIED: Don't update if user is dragging

    try {
      const isX = axis === 'x';
      const svg = isX ? this.xBrushSvg : this.yBrushSvg;
      const brush = isX ? this.brushX : this.yBrush;
      const dimension = isX ? this.currentDimensions?.width : this.currentDimensions?.height;

      if (!svg || !brush || !dimension) return;

      const padding = 10;

      if (isX) {
        const yAxisWidth = this.showPatientIDs ? this.yAxisWidth : 0;
        const mainCanvasWidth = this.mainCanvas.clientWidth - yAxisWidth;

        const brushContainerWidth = this.pixelMapContainer.nativeElement.clientWidth;
        const brushPixelWidth = brushContainerWidth - this.margin.left - this.margin.right;
        const brushPixelLeft = padding;
        const brushPixelRight = brushPixelWidth - padding;

        // 1. Update brush scale's domain and range
        this.brushXScale
          .domain([0, dimension])
          .range([brushPixelLeft, brushPixelRight]);

        const brushPixelHeight = this.brushHeight - this.brushMargin.top - this.brushMargin.bottom;
        this.brushX.extent([
          [brushPixelLeft, 0],
          [brushPixelRight, brushPixelHeight]
        ]);

        // 2. Calculate visible data range from viewTransform
        const { kx, x } = this.viewTransform;
        const visibleDataStart = -x / kx;
        const visibleDataEnd = visibleDataStart + (mainCanvasWidth / kx);

        // 3. Translate data range to brush pixel selection
        const brushPixelStart = this.brushXScale(visibleDataStart);
        const brushPixelEnd = this.brushXScale(visibleDataEnd);

        // 4. Programmatically move the brush
        const brushGroup = svg.select<SVGGElement>('g.brush');
        if (!brushGroup.empty()) {
          brushGroup.call(this.brushX);
          const clampedStart = Math.max(brushPixelLeft, brushPixelStart);
          const clampedEnd = Math.min(brushPixelRight, brushPixelEnd);
          brushGroup.call(this.brushX.move, [clampedStart, clampedEnd]);

          // --- FIX: Enforce minimum brush gap ---
          const minGap = 20;
          if (clampedEnd - clampedStart < minGap) {
             const center = (clampedStart + clampedEnd) / 2;
             const safeStart = Math.max(brushPixelLeft, center - minGap / 2);
             const safeEnd = Math.min(brushPixelRight, safeStart + minGap);
             // Re-adjust start if end hit the wall
             const finalStart = Math.max(brushPixelLeft, safeEnd - minGap);
             brushGroup.call(this.brushX.move, [finalStart, safeEnd]);
             this.updateHandlePositions(brushGroup, [finalStart, safeEnd], 'x');
          } else {
             // Standard update handles
             this.updateHandlePositions(brushGroup, [clampedStart, clampedEnd], 'x');
          }
        }
      } else {
        const headerHeight = this.currentView === 'standard' ? 0 : 30;
        const mainCanvasHeight = this.mainCanvas.clientHeight - headerHeight;

        const brushContainerHeight = this.pixelMapContainer.nativeElement.clientHeight - this.brushHeight;
        const brushPixelTop = padding;
        const brushPixelBottom = brushContainerHeight - padding;

        // 1. Update brush scale's domain and range
        this.yBrushScale
          .domain([0, dimension])
          .range([brushPixelTop, brushPixelBottom]);

        const brushHandleWidth = 24; // Match visual handle width
        this.yBrush.extent([
          [0, brushPixelTop],
          [brushHandleWidth, brushPixelBottom]
        ]);

        // 2. Calculate visible data range from viewTransform
        const { ky, y } = this.viewTransform;
        const visibleDataStart = -y / ky;
        const visibleDataEnd = visibleDataStart + (mainCanvasHeight / ky);

        // 3. Translate data range to brush pixel selection
        const brushPixelStart = this.yBrushScale(visibleDataStart);
        const brushPixelEnd = this.yBrushScale(visibleDataEnd);

        // 4. Programmatically move the brush
        const brushGroup = svg.select<SVGGElement>('g.y-brush');
        if (!brushGroup.empty()) {
          brushGroup.call(this.yBrush);
          const clampedStart = Math.max(brushPixelTop, brushPixelStart);
          const clampedEnd = Math.min(brushPixelBottom, brushPixelEnd);
          brushGroup.call(this.yBrush.move, [clampedStart, clampedEnd]);

          // FIX: Manually update handles after programmatic move
          this.updateHandlePositions(brushGroup, [clampedStart, clampedEnd], 'y');
        }
      }
    } catch (error) {
      console.error(`Error updating ${axis} brush from transform:`, error);
    }
  }







  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalRecords']) {
      this.totalPages = Math.ceil((this.totalRecords || 0) / this.paginationPageSize);
    }

    if ((changes['data']?.currentValue != changes['data']?.previousValue || changes['dataStartIndex']?.currentValue != changes['dataStartIndex']?.previousValue) && this.initiateChart) {
      setTimeout(() => {
        this.getPixelMapData();
      }, 200);
    }
  }

  private goToPrescriberCard(patientId: string): void {
      console.log("Navigating to Prescriber Card for", patientId);

      if(!this.item.config?.['nav_configuration']) {
          console.warn("Navigation configuration missing");
          return;
      }
      
      // We assume the second control is for the individual card, or we search for it?
      // Or we reuse the first one but with a different page name?
      // Usually config has multiple controls. Let's look for one that might be 'prescriber_card' or similar?
      // Or typically: controls[0] is main list, controls[1] might be detail?
      // The user requirement said: "change my "y-axis-labels" to be blue links that when clicked goes to that Patients prescriber card"
      // I will assume controls[1] exists and is correct, OR I will try to infer.
      // Safe bet: The user mentioned "Network Chart" logic. 
      // In Network Chart, tooltip links use specific names.
      // Let's assume controls[0] is the config, and we just need to pass the ID.
      // But "Prescriber Card" is a different PAGE than "Patient List".
      
      // Let's try to find a control with pageName 'Prescriber Card' or similar if array.
      // If not, fallback to a default expectation or controls[0] with override.
      
      const navConfig = this.item.config['nav_configuration'];
      let targetConf = navConfig.controls.find((c: any) => c.pageName.toLowerCase().includes('card') || c.pageName.toLowerCase().includes('prescriber'));
      
      if (!targetConf) {
          // Fallback: Use controls[0] but maybe it's the wrong page.
          // If the user said "Patient List" button goes to "Patient List", 
          // and Y-axis goes to "Prescriber Card", they must be different.
          // Let's assume controls[1] if available, else controls[0].
          targetConf = navConfig.controls.length > 1 ? navConfig.controls[1] : navConfig.controls[0];
      }

      let nav = {
        dbJSON: targetConf.dbJSON,
        s3JSON: targetConf.s3JSON,
        pageName: targetConf.pageName,
        isDashboardLevel: targetConf.isDashboardLevel
      }

      // Payload: We need to pass the Patient ID. 
      // The key usually matches the column name in the DB, e.g. 'LH_PATIENT_ID' or 'patient_key'.
      // We should use the key defined in config 'payloadData'.
      const payloadKey = targetConf.payloadData || 'LH_PATIENT_ID'; 
      const payload = { [payloadKey]: patientId };

      this.routerHandlerService.navDetailInfo(nav);
      this.routerHandlerService.storingPayloadAndFilterForGrid(targetConf, payload, '');

      let query: any = Object.assign({}, this.decryptedParams, { tab_id: 0 }, { page: 'card' });
      let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
      this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${nav.pageName}`, queryMaped);
  }

  serverSideSearchEmits(event: any) {
    let filterValue = event?.filterValue
    let filterSearchParams = filterValue ? (event?.obj || '') : '';

    // remove empty spaces and put in commas
    filterValue = filterValue.split(/[\s,]+/)   // Split on any combination of spaces (\s) or commas (,)
      .filter(Boolean)   // Remove empty strings (handles leading/trailing spaces)
      .join(',');        // Join back with a single comma;

    let filterSearchKey = event.hdr.searchByKey.find((f: any) => f.value == event.obj.search_prm)


    // set Search state
    // let config = {
    //   id: this.widgetUniqKey,
    //   config: {
    //     dashboardKey: this.dashboardKey,
    //     filterValue: this.filterValue,
    //     search: this.filterSearchParams,
    //     searchDynamicParams: this.searchDynamicParams
    //   }
    // }

    this.filterQueryChange.emit({ [filterSearchKey.param]: filterValue });
  }

  searchPixelMap(event: any) {
    const rawInput = event.toLowerCase();

    // 1. Split the input string by commas or spaces, then clean up the array.
    const searchTerms = rawInput
      .split(/,|\s+/)              // Split by comma OR one or more whitespace characters
      .map(term => term.trim())     // Remove extra whitespace from each term
      .filter(term => term !== ''); // Remove any empty strings from the array

    if (searchTerms.length === 0) {
      // 2. If there are no valid search terms, restore the full list.
      this.patientIds = [...this.allPatientIdsMaster];
    } else {
      // 3. Filter the master list. A patient ID is a match if it includes ANY of the search terms.
      this.patientIds = this.allPatientIdsMaster.filter(id =>
        searchTerms.some(term => id.toLowerCase().includes(term))
      );
    }

    // 4. Reset pagination and re-render the chart with the new list of patients.
    this.currentPage = 0;
    // Recalculate total pages based on filtered result
    this.totalPages = Math.ceil(this.patientIds.length / this.paginationPageSize);
    this.processPageDataAndRender();
  }

  nextPage() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.pageChange.emit(this.currentPage);
      this.processPageDataAndRender();
    }
  }

  public setPage(page: number) {
    if (page >= 0 && page < this.totalPages) {
      this.currentPage = page;
      this.pageChange.emit(this.currentPage);
      this.processPageDataAndRender();
    }
  }

  public resetPages() {
    this.currentPage = 0;
  }

  previousPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.pageChange.emit(this.currentPage);
      this.processPageDataAndRender();
    }
  }

  firstPage() {
    if (this.currentPage !== 0) {
      this.currentPage = 0;
      this.pageChange.emit(this.currentPage);
      this.processPageDataAndRender();
    }
  }

  lastPage() {
    if (this.currentPage !== this.totalPages - 1) {
      this.currentPage = this.totalPages - 1;
      this.pageChange.emit(this.currentPage);
      this.processPageDataAndRender();
    }
  }

  // Set up common SVG elements
  initiateCharts(): void {
    this.initiateChart = true;
    // this.initializeAllData();
    // this.processPageDataAndRender();
    // this.getPixelMapData();
  }

  getPixelMapData() {
    this.allPixelData = this.data;
    this.isLoading = false;

    if (this.allPixelData !== undefined && this.allPixelData.length > 0) {
      this.noData = false
      this.initializeAllData();
      // this.setAnalyticalMode(false);
      this.processPageDataAndRender();
    } else {
      this.noData = true
      // Clear canvas if no data
      if (this.mainCtx) this.mainCtx.clearRect(0, 0, this.mainCanvas.width, this.mainCanvas.height);
    }
  }

  public setView(view: 'standard' | 'calendar' | 'time' | 'table'): void {
    // We only need to check if there's data. The animation function will handle the rest.
    if (!this.allPixelData?.length) {
      return;
    }
    this.currentView = view;

    if (view === 'table') {
      this.prepareTableData();
      return;
    }

    // 2. Reset the pan/zoom state for the new view
    this.resetZoom();

    // Force a redraw to ensure canvas is populated after being hidden
    setTimeout(() => {
      this.updateCanvasSizes();
      this.renderMain();
    }, 50);

    // 3. Trigger animation if needed (optional, or just render directly)
    // this.animateCanvasToView(view);
  }

  prepareTableData() {
    this.rowData = this.allPixelData || [];

    this.columnDefs = [
      { field: 'LH_PATIENT_ID', headerName: 'Patient ID', filter: true, sortable: true },
      { field: 'STATUS_DATE', headerName: 'Status Date', filter: true, sortable: true },
      { field: 'STATUS_REASON_CODE', headerName: 'Status Code', filter: true, sortable: true },
      { field: 'STATUS_REASON_CODE_DESC', headerName: 'Description', filter: true, sortable: true },
      { field: 'STATUS_GROUP', headerName: 'Status Group', filter: true, sortable: true },
      { field: 'STATUS_SUB_GROUP', headerName: 'Sub Group', filter: true, sortable: true },
      { field: 'CURRENT_REFERRAL_STATUS', headerName: 'Current Status', filter: true, sortable: true },
      { field: 'SP_DESCRIPTION', headerName: 'Source', filter: true, sortable: true }
    ];

    if (this.gridApi) {
      this.gridApi.setRowData(this.rowData);
    }
  }

  // Ensure your resetZoom method looks like this:
  public resetZoom(): void {
    // Standard view typically starts at 1 (or fitted). Time/Calendar starts at initialKy (1.8).
    const targetKy = (this.currentView === 'time' || this.currentView === 'calendar')
      ? this.initialKy
      : 1;
    this.viewTransform = { x: 0, y: 0, kx: 1, ky: targetKy };

    // Clear X-brush selection
    if (this.xBrushSvg && this.brushX) {
      const brushGroup = this.xBrushSvg.select<SVGGElement>('g.brush');
      if (!brushGroup.empty()) {
        brushGroup.call(this.brushX.move, null);
      }
    }

    // --- NEW: Clear Y-brush selection ---
    if (this.yBrushSvg && this.yBrush) {
      const yBrushGroup = this.yBrushSvg.select<SVGGElement>('g.y-brush');
      if (!yBrushGroup.empty()) {
        yBrushGroup.call(this.yBrush.move, null);
      }
    }

    this.renderMain();
  }

  changeDisplayType(selectedType: any) {
    this.selectedType = selectedType;
    this.setView(selectedType);
  }

  public openManageStatusesDialog(focusOn?: PixelData): void {
    if (this.manageStatusesDialogRef) {
      return;
    }

    this.manageStatusesDialogRef = this.dialog.open(ManageStatusesDialogComponent, {
      width: 'auto',
      maxWidth: '80vw', // Optional: Safety cap
      hasBackdrop: false,
      data: {
        hierarchy: this.useAnalyticalMode ? this.analyticalHierarchyState : this.statusHierarchy,
        focusOn: focusOn,
        patientJourneyMap: this.patientJourneyMap,
        ruleSet: this.currentRuleSet || this.storedRuleSet, // Pass current or stored query
        updateCallback: (updatedHierarchy: StatusGroup[]) => {
          if (this.useAnalyticalMode) {
            this.analyticalHierarchyState = updatedHierarchy;
            this.buildAnalyticalMap();
          } else {
            // Standard Mode: Update hierarchy and rebuild lookup map
            this.statusHierarchy = updatedHierarchy;
            
            // Rebuild reasonLookupMap to ensure references match the new hierarchy
            this.reasonLookupMap.clear();
            this.statusHierarchy.forEach(referral => {
              referral.groups.forEach(group => {
                group.subGroups.forEach(subGroup => {
                  subGroup.reasons.forEach(reason => {
                    this.reasonLookupMap.set(reason.code, {
                      color: reason.color,
                      reasonRef: reason,
                      subGroupRef: subGroup,
                      parentGroupRef: group,
                      referralRef: referral
                    });
                  });
                });
              });
            });
          }
          this.updateLegendData();
          this.renderMain();
        }
      },
    });

    // --- MODIFIED afterClosed() logic ---
    this.manageStatusesDialogRef.afterClosed().subscribe((result: any) => {
      this.manageStatusesDialogRef = null;
      if (result && result.action === 'queryApply') {
        // Set mode, update state, and REBUILD THE MAP ---
        this.setAnalyticalMode(true);
        this.analyticalHierarchyState = result.hierarchy;
        this.buildAnalyticalMap(); // <-- This is the crucial fix



        const newRuleSet = result.ruleSet as RuleSet;
        this.applyRuleSet(newRuleSet);

        // Update stored state and persist
        this.storedRuleSet = newRuleSet;
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(newRuleSet));

        // --- Emit the SQL Query ---
        if (result.param && result.param.filter_query !== undefined) {
          this.filterQueryChange.emit(result.param);
        }

        this.updateLegendData();
      } else if (result && result.action === 'statusApply') {
        // --- FIX: Capture the modified hierarchy from the dialog ---
        if (result.hierarchy) {
          this.analyticalHierarchyState = result.hierarchy;
          this.buildAnalyticalMap();
          this.updateLegendData();
        }
        // User explicitly confirmed, set/keep analytical mode
        this.setAnalyticalMode(true);
      } else if (result && result.action === 'queryReset') {
        // User explicitly cancelled, exit analytical mode
        // this.setAnalyticalMode(false);
        // User explicitly cancelled, exit analytical mode
        if (result.param) {
          // Reset the hierarchy if provided in the result
          if (result.hierarchy) {
            this.analyticalHierarchyState = result.hierarchy;
            this.buildAnalyticalMap();
            this.updateLegendData();
          }
          this.setAnalyticalMode(false);
          this.filterQueryChange.emit(result.param);
        }
      } else if (result && result.action === 'close') {
        // User explicitly cancelled, exit analytical mode
        // this.setAnalyticalMode(false);
      } else if (result && result.action === 'cancel') {
        // User explicitly cancelled, exit analytical mode
        this.setAnalyticalMode(false);
      } else if (result && result.action === 'aiQuery') {
        // Handle AI Query
        if (result.param) {
          this.filterQueryChange.emit(result.param);
        }
      }
      this.renderMain(); // Helper to redraw the canvas
    });
  }

  // Helper function to call the canvas redraw if it exists
  private redrawFrame(): void {
    if ((this as any).__drawFrame) {
      (this as any).__drawFrame(1);
    }
  }

  private applyRuleSet(ruleSet: RuleSet, render: boolean = true): void {
    const isNewRuleSet = ruleSet !== this.currentRuleSet;
    this.currentRuleSet = ruleSet;
    // 1. Reset the condition for all currently visible data points
    this.allPixelData.forEach(p => p.isConditionMet = false);

    console.log('Applying RuleSet:', ruleSet);

    if (isNewRuleSet) {
      this.syncHierarchyWithQuery(ruleSet);
      this.updateLegendData();
    }

    if (!ruleSet || ruleSet.rules.length === 0) {
      // If no rules, we might want to highlight everything or nothing?
      // Usually "no filter" means "show everything".
      // Let's set everything to true so they are all colored.
      this.allPixelData.forEach(p => p.isConditionMet = true);
      if (render) this.renderMain();
      return;
    }

    // 2. Iterate through the visible pixels (allPixelData) and check criteria
    // 2. Iterate through the visible pixels (allPixelData) and check criteria
    // OPTIMIZATION: Cache result of doesJourneySatisfy per patient to avoid re-evaluating for every pixel
    const patientJourneySatisfiedCache = new Map<string, boolean>();

    this.allPixelData.forEach(pixel => {
      // For journey-level rules, we need the full patient history
      // We can get this from the map using the pixel's patient ID
      const fullJourney = this.patientJourneyMap.get(pixel.LH_PATIENT_ID) || [];

      // Lazy load the journey satisfaction check
      let isJourneySatisfied = patientJourneySatisfiedCache.get(pixel.LH_PATIENT_ID);
      if (isJourneySatisfied === undefined) {
         // Optimization: If the ruleset condition is 'and', we can pre-check the journey.
         // If 'or', the journey check is not global, but per-branch, so we can't skip it entirely,
         // but evaluateRuleOrSet handles 'or' branches correctly (skipping doesn't apply there).
         // However, doesJourneySatisfy(ruleSet) works for OR too (returns true if ANY branch matches).
         // If it returns false for OR, then NO branch matches journey -> Pixel cannot match.
         // So we CAN use this filter for both AND and OR types.
         isJourneySatisfied = this.doesJourneySatisfy(ruleSet, fullJourney);
         patientJourneySatisfiedCache.set(pixel.LH_PATIENT_ID, isJourneySatisfied);
      }

      if (!isJourneySatisfied) {
        // Pixel's patient doesn't match the criteria at all
        return;
      }

      // Evaluate the ruleset recursively
      // We pass 'true' for skipJourneyCheck because we just verified it above!
      const isMatch = this.evaluateRuleOrSet(ruleSet, pixel, fullJourney, true);

      if (isMatch) {
        pixel.isConditionMet = true;
      }
    });

    const matchCount = this.allPixelData.filter(p => p.isConditionMet).length;
    console.log(`RuleSet applied. Matches found: ${matchCount} / ${this.allPixelData.length}`);

    // 3. Re-render to show the changes
    // We do NOT reset pagination or filter the patient list.
    if (render) this.renderMain();
  }

  private syncHierarchyWithQuery(ruleSet: RuleSet): void {
    this.queryStatusCodes.clear();
    if (!ruleSet) return;

    const traverse = (item: Rule | RuleSet) => {
      if (item.type === 'ruleset') {
        (item as RuleSet).rules.forEach(traverse);
      } else {
        const rule = item as Rule;
        if (rule.field === 'STATUS_REASON_CODE' && rule.operator === 'is one of' && Array.isArray(rule.value)) {
          (rule.value as StatusReason[]).forEach(r => {
            this.queryStatusCodes.add(r.code);
            // Sync with hierarchy
            const lookup = this.useAnalyticalMode ? this.analyticalReasonLookupMap.get(r.code) : this.reasonLookupMap.get(r.code);
            if (lookup) {
              lookup.reasonRef.checked = true;
              this.updateSubGroupCheckbox(lookup.subGroupRef);
              this.updateParentCheckbox(lookup.parentGroupRef);
            }
          });
        }
      }
    };
    traverse(ruleSet);
  }

  private evaluateRuleOrSet(item: Rule | RuleSet, pixel: PixelData, fullJourney: JourneyEvent[], skipJourneyCheck: boolean = false): boolean {
    if (item.type === 'ruleset') {
      const ruleset = item as RuleSet;
      if (!ruleset.rules || ruleset.rules.length === 0) return true;

      if (ruleset.condition === 'and') {
        // AND Logic:
        // 1. The JOURNEY must satisfy ALL child conditions.
        // OPTIMIZATION: If skipJourneyCheck is true, we assume this has already been verified by a parent (or cache)
        if (!skipJourneyCheck) {
            const journeySatisfiesAll = ruleset.rules.every(child => this.doesJourneySatisfy(child, fullJourney));
            if (!journeySatisfiesAll) return false;
        }

        // 2. The PIXEL must satisfy the logic:
        // - "Matchers" (Positive Status Rules, Nested RuleSets) -> UNION (Match Any)
        // - "Constraints" (Date, Negative Status, etc.) -> INTERSECTION (Match All)

        const matchers: (Rule | RuleSet)[] = [];
        const constraints: (Rule | RuleSet)[] = [];

        for (const child of ruleset.rules) {
          if (child.type === 'ruleset') {
            // Nested RuleSets are "Matchers" (they define a complex event we are looking for)
            matchers.push(child);
          } else {
             // Basic Rules
             const rule = child as Rule;
             // Check for Advanced Rules first
             if (rule.rule_type === 'Advanced') {
               matchers.push(rule);
             } else if (rule.field === 'STATUS_REASON_CODE' && rule.operator === 'is one of') {
               // Positive Status Rules are "Matchers"
               matchers.push(rule);
             } else {
               // Date, Negative Status, Duration are "Constraints"
               constraints.push(rule);
             }
          }
        }

        // A. Check Constraints (Intersection) - Must match ALL
        for (const constraint of constraints) {
          // If we are here, skipJourneyCheck is effectively true for "this" ruleset.
          // Since this is AND logic, if THIS ruleset matches journey, all children usually do.
          // Constraints are Rules -> skipped. 
          // Matchers are Rules or RuleSets -> If RuleSet, we can pass true.
          if (!this.evaluateRuleOrSet(constraint, pixel, fullJourney, true)) {
            return false;
          }
        }

        // B. Check Matchers (Union) - Must match AT LEAST ONE (if any exist)
        if (matchers.length > 0) {
          let matchedAnyMatcher = false;
          for (const matcher of matchers) {
             // Pass true because if parent (AND) is valid, children are usually valid for journey check
            if (this.evaluateRuleOrSet(matcher, pixel, fullJourney, true)) {
              matchedAnyMatcher = true;
              break;
            }
          }
          if (!matchedAnyMatcher) {
            return false;
          }
        }

        return true;
      } else {
        // OR Logic:
        // The pixel just needs to match ONE of the branches.
        // For OR logic, we CANNOT skip journey checks on children because only ONE branch needs to be valid.
        return ruleset.rules.some(child => this.evaluateRuleOrSet(child, pixel, fullJourney, false));
      }
    } else {
      const rule = item as Rule;
      if (!rule.enabled) return true;

      // Rules do NOT perform journey checks inside evaluateRuleOrSet (they only do pixel checks)
      // The journey check (if any) was implicit in the container's logic.
      
      if (rule.rule_type === 'Advanced') {
        if (rule.operator === 'followed by' || rule.operator === 'followed by directly') {
           return this.doesEventMatchSequence(pixel, rule, fullJourney);
        } else if (rule.operator === 'duration between') {
           return this.doesJourneyMatchDurationRule(fullJourney, rule, pixel);
        }
        return this.doesEventMatchAdvancedRule(pixel, rule, fullJourney);
      } else if (rule.operator === 'duration between') {
        return this.doesJourneyMatchDurationRule(fullJourney, rule, pixel);
      } else {
        return this.doesEventMatchPropertyRule(pixel, rule);
      }
    }
  }

  /**
   * Checks if the PATIENT JOURNEY satisfies the rule/ruleset.
   * This is distinct from whether a specific pixel matches.
   */
  private doesJourneySatisfy(item: Rule | RuleSet, fullJourney: JourneyEvent[]): boolean {
    if (item.type === 'ruleset') {
      const ruleset = item as RuleSet;
      if (!ruleset.rules || ruleset.rules.length === 0) return true;

      if (ruleset.condition === 'and') {
        return ruleset.rules.every(child => this.doesJourneySatisfy(child, fullJourney));
      } else {
        return ruleset.rules.some(child => this.doesJourneySatisfy(child, fullJourney));
      }
    } else {
      const rule = item as Rule;
      if (!rule.enabled) return true;

      if (rule.rule_type === 'Advanced') {
         if (!fullJourney || fullJourney.length === 0) return false;
         
         if (rule.operator === 'FIRST_STATUS') {
            return fullJourney[0].STATUS_REASON_CODE === rule.value;
         }
         if (rule.operator === 'LAST_STATUS') {
            return fullJourney[fullJourney.length - 1].STATUS_REASON_CODE === rule.value;
         }
         // Sequential Rules are also Advanced now
         if (rule.operator === 'followed by' || rule.operator === 'followed by directly') {
            return this.doesJourneyMatchSequence(fullJourney, rule);
         }
         if (rule.operator === 'duration between') {
            return this.doesJourneyMatchDurationRule(fullJourney, rule);
         }
         return false;
      } else if (rule.operator === 'duration between') {
        return this.doesJourneyMatchDurationRule(fullJourney, rule);
      } else {
        // For a property rule, does ANY event in the journey match?
        return fullJourney.some(event => this.doesEventMatchPropertyRule(event, rule));
      }
    }
  }

  private doesJourneyMatchSequence(journey: JourneyEvent[], rule: Rule): boolean {
    if (!journey || journey.length === 0) return false;
    
    // rule.value is [[Reason, Reason], [Reason]] (Steps)
    // We need to flatten to codes for easier comparison
    const steps: string[][] = [];
    if (Array.isArray(rule.value)) {
      // Check if it's already codes (strings) or objects
      if (rule.value.every(step => Array.isArray(step))) {
        steps.push(...rule.value.map((step: any[]) => step.map(s => s.code || s)));
      }
    }
  
    if (steps.length === 0) return false;
  
    const isStrict = rule.operator === 'followed by directly';
  
    if (isStrict) {
        // Strict: A -> B -> C (Immediate)
        // We look for the first step, then check subsequent immediately
        for (let i = 0; i <= journey.length - steps.length; i++) {
            if (this.isMatch(journey[i], steps[0])) {
                let fullMatch = true;
                for (let k = 1; k < steps.length; k++) {
                    if (!this.isMatch(journey[i + k], steps[k])) {
                        fullMatch = false;
                        break;
                    }
                }
                if (fullMatch) return true;
            }
        }
        return false;
    } else {
        // Loose: A ... B ... C (With gaps)
        let currentStepIndex = 0;
        let lastMatchIndex = -1;
  
        for (let i = 0; i < journey.length; i++) {
            if (this.isMatch(journey[i], steps[currentStepIndex])) {
                // Found match for current step
                lastMatchIndex = i;
                currentStepIndex++;
                if (currentStepIndex >= steps.length) {
                    return true;
                }
            }
        }
        return false;
    }
  }
  
  private isMatch(event: JourneyEvent, allowedCodes: string[]): boolean {
      return allowedCodes.includes(event.STATUS_REASON_CODE);
  }
  
  private doesEventMatchSequence(pixel: PixelData, rule: Rule, fullJourney: JourneyEvent[]): boolean {
      // For rendering/highlighting, we will highlight ANY event that matches ANY of the codes in the sequence
      // IF the sequence condition itself is met (which is checked via skipJourneyCheck optimization in parent).
      
      // 1. Flatten all allowed codes in the sequence
      const allCodes = new Set<string>();
       if (Array.isArray(rule.value)) {
           rule.value.forEach((step: any[]) => {
               if (Array.isArray(step)) {
                   step.forEach(s => allCodes.add(s.code || s));
               }
           });
       }
       
       return allCodes.has(pixel.STATUS_REASON_CODE);
  }

  private doesEventMatchAdvancedRule(pixel: PixelData, rule: Rule, fullJourney: JourneyEvent[]): boolean {
    if (!fullJourney || fullJourney.length === 0) return false;

    // Assume sorted as per requirements
    if (rule.operator === 'FIRST_STATUS') {
      const firstEvent = fullJourney[0];
      // Check if this pixel IS the first event (by reference or ID + status)
      // Since pixel is a PixelData which extends JourneyEvent, we can compare specific fields unique to the event
      // Best to compare by object equality if they are the same objects, but data might be cloned.
      // Let's compare keys if available, or strict equality.
      // The pixel object comes from `this.allPixelData`, and `fullJourney` comes from `this.patientJourneyMap`.
      // `this.allPixelData` likely contains objects from `fullJourney` enriched with pixel data.
      // Let's try matching unique properties: PatientID + Date + Status + JourneyStop
      
      const isFirstEvent = (
        pixel.LH_PATIENT_ID === firstEvent.LH_PATIENT_ID &&
        pixel.STATUS_REASON_CODE === firstEvent.STATUS_REASON_CODE &&
        // Handle potential Date objects or string dates
        new Date(pixel.STATUS_DATE).getTime() === new Date(firstEvent.STATUS_DATE).getTime()
      );

      if (!isFirstEvent) return false;
      return pixel.STATUS_REASON_CODE === rule.value;
    }

    if (rule.operator === 'LAST_STATUS') {
      const lastEvent = fullJourney[fullJourney.length - 1];
      const isLastEvent = (
        pixel.LH_PATIENT_ID === lastEvent.LH_PATIENT_ID &&
        pixel.STATUS_REASON_CODE === lastEvent.STATUS_REASON_CODE &&
        new Date(pixel.STATUS_DATE).getTime() === new Date(lastEvent.STATUS_DATE).getTime()
      );

      if (!isLastEvent) return false;
      return pixel.STATUS_REASON_CODE === rule.value;
    }

    return false;
  }

  private doesEventMatchPropertyRule(event: JourneyEvent, rule: Rule): boolean {
    // Get the value from the event object based on the rule's field
    const eventValue = event[rule.field as keyof JourneyEvent];
    const ruleValue = rule.value;

    // If either value is missing, it cannot be a match
    if (eventValue === undefined || ruleValue === null || ruleValue === undefined) {
      return false;
    }

    switch (rule.field) {
      case 'STATUS_REASON_CODE':
        // The rule value is an array of StatusReason objects
        const selectedCodes = new Set((ruleValue as StatusReason[]).map(r => r.code));
        if (rule.operator === 'is one of') {
          return selectedCodes.has(eventValue);
        }
        if (rule.operator === 'is not one of') {
          return !selectedCodes.has(eventValue);
        }
        break;

      case 'STATUS_DATE':
      case 'PATIENT_INITIATED_DATE':
        // Normalize the event's date to midnight for accurate comparison
        const eventDate = new Date(eventValue).setHours(0, 0, 0, 0);

        // --- NEW LOGIC FOR DATE RANGE ---
        if (rule.operator === 'is between') {
          // Ensure the start and end dates from the picker exist
          if (!ruleValue.start || !ruleValue.end) {
            return false;
          }
          // Normalize the rule's start and end dates to midnight
          const startDate = new Date(ruleValue.start).setHours(0, 0, 0, 0);
          const endDate = new Date(ruleValue.end).setHours(0, 0, 0, 0);
          // Check if the event date is on or after the start AND on or before the end
          return eventDate >= startDate && eventDate <= endDate;
        }
        // --- END NEW LOGIC ---
        else {
          // Logic for single date operators remains the same
          const ruleDate = new Date(ruleValue).setHours(0, 0, 0, 0);
          if (rule.operator === 'is on') return eventDate === ruleDate;
          if (rule.operator === 'is before') return eventDate < ruleDate;
          if (rule.operator === 'is after') return eventDate > ruleDate;
        }
        break;
    }
    return false;
  }

  /**
   * Checks if a journey has a duration event matching the rule.
   * If a `pixel` is provided, it returns true ONLY if that pixel corresponds to the start or end event of the matching duration.
   */
  private doesJourneyMatchDurationRule(events: JourneyEvent[], rule: Rule, pixel?: JourneyEvent): boolean {
    // Ensure all necessary properties for a duration rule exist
    if (!rule.startStatus?.length || !rule.endStatus?.length) {
      return false;
    }
    
    // Check if we have the necessary value fields
    if (rule.operatorType === 'BETWEEN') {
        if (rule.min_days === undefined || rule.max_days === undefined) return false;
    } else if (rule.operatorType) {
        if (rule.value === undefined || rule.value === null) return false;
    } else {
        // Legacy check
        if (rule.days === undefined) return false;
    }

    // Create Sets for efficient lookup
    const startStatusCodes = new Set(rule.startStatus.map(s => s.code));
    const endStatusCodes = new Set(rule.endStatus.map(s => s.code));

    // Find the first event in the journey that matches a start status
    const firstStartEvent = events.find(event => startStatusCodes.has(event.STATUS_REASON_CODE));
    if (!firstStartEvent) {
      return false; // No matching start event found in this journey
    }

    // Find the first event AFTER the start event that matches an end status
    const startIndex = events.indexOf(firstStartEvent);
    const firstEndEvent = events.find((event, index) =>
      index > startIndex && endStatusCodes.has(event.STATUS_REASON_CODE)
    );

    if (!firstEndEvent) {
      return false; // No subsequent matching end event found
    }

    // Calculate the duration in days
    const duration = (new Date(firstEndEvent.STATUS_DATE).getTime() - new Date(firstStartEvent.STATUS_DATE).getTime()) / (1000 * 60 * 60 * 24);

    console.log(`Duration check for patient ${firstStartEvent.LH_PATIENT_ID}: ${duration} days. Rule: ${rule.operatorType} ${rule.min_days}-${rule.max_days} or ${rule.value}`);

    // Check if the duration meets the rule's condition
    let durationMatches = false;
    if (rule.operatorType) {
        const val = Number(rule.value);
        switch (rule.operatorType) {
            case 'BETWEEN':
                durationMatches = duration >= (rule.min_days!) && duration <= (rule.max_days!);
                break;
            case '=':
                // Use a small epsilon for float comparison if needed, or strict equality if integer days
                durationMatches = Math.abs(duration - val) < 0.1;
                break;
            case '>':
                durationMatches = duration > val;
                break;
            case '<':
                durationMatches = duration < val;
                break;
            case '>=':
                durationMatches = duration >= val;
                break;
            case '<=':
                durationMatches = duration <= val;
                break;
        }
    } else if (rule.days !== undefined) {
         // Fallback Legacy
        if (rule.durationOperator === 'gt') {
          durationMatches = duration > rule.days;
        } else { // 'lt'
          durationMatches = duration < rule.days;
        }
    }

    if (!durationMatches) return false;

    // If a specific pixel (event) is provided, we must check if THIS pixel is part of the duration (start or end)
    if (pixel && pixel.STATUS_REASON_CODE) {
       // Is this pixel the start event?
       const isStart = pixel.STATUS_REASON_CODE === firstStartEvent.STATUS_REASON_CODE && pixel.STATUS_DATE === firstStartEvent.STATUS_DATE;
       // Is this pixel the end event?
       const isEnd = pixel.STATUS_REASON_CODE === firstEndEvent.STATUS_REASON_CODE && pixel.STATUS_DATE === firstEndEvent.STATUS_DATE;
       
       return isStart || isEnd;
    }

    return true;
  }

  /**
  * A faster, recursive function to deep-clone the hierarchy object.
  */
  public cloneHierarchy(layers: ReferralLayer[]): ReferralLayer[] {
    return layers.map(layer => ({
      ...layer,
      // 1. Deep copy the groups array within the referral layer
      groups: layer.groups.map(group => ({
        ...group,
        // 2. Deep copy the subGroups within the group
        subGroups: group.subGroups.map(subGroup => ({
          ...subGroup,
          // 3. Deep copy the reasons within the subGroup
          reasons: subGroup.reasons.map(reason => ({ ...reason }))
        }))
      }))
    }));
  }

  // Set up mouse interaction listeners
  private setupInteractionListeners(): void {
    if (!this.mainCanvas) return;

    // Attach listeners that call class methods
    this.mainCanvas.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.mainCanvas.addEventListener('mousemove', this.handleMouseMove.bind(this));
    this.mainCanvas.addEventListener('mouseup', this.handleMouseUp.bind(this));
    this.mainCanvas.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  }


  private initializeAllData(): void {
    // --- 1. Create the Status Lookup Map ---
    const statusLookup = new Map<string, any>();
    for (const statusDim of this.parentData) {
      statusLookup.set(statusDim.patient_reason_code, statusDim);
    }

    // --- 2. Create the "Joined" Data ---
    const joinedData: JourneyEvent[] = this.data.map(event => {
      const statusInfo = statusLookup.get(event.status_reas_cd) || {};
      return {
        LH_PATIENT_ID: event.patient_key.toString(),
        STATUS_DATE: event.tran_dt,
        STATUS_REASON_CODE: event.status_reas_cd,
        PATIENT_INITIATED_DATE: event.patient_initiated_date,
        STATUS_REASON_CODE_DESC: statusInfo.patient_reason_code_desc,
        STATUS_GROUP: statusInfo.patient_status_group,
        STATUS_SUB_GROUP: statusInfo.patient_status_sub_group,
        CURRENT_REFERRAL_STATUS: statusInfo.patient_status,
        JOURNEY_STOP: statusInfo.sp_hub_ind,
        SP_DESCRIPTION: event.data_source_name // Assuming sp_name maps to SP_DESCRIPTION based on dialog usage
      };
    }).filter(d => d.STATUS_GROUP);

    // --- 3. Group Data ---
    this.patientJourneyMap = d3.group(joinedData, d => d.LH_PATIENT_ID);

    // FILTERING LOGIC... (Same as before)
    const payloadData = JSON.parse(sessionStorage.getItem("payloadData") || '{}');
    let patientIdsToDisplay = [];
    if (payloadData?.patient_ids) {
      patientIdsToDisplay = payloadData.patient_ids.map(String); // Ensure strings
    }
    const allPatientIds = Array.from(this.patientJourneyMap.keys());
    this.allPatientIdsMaster = allPatientIds;

    if (patientIdsToDisplay && patientIdsToDisplay.length > 0) {
      const patientIdSet = new Set(patientIdsToDisplay);
      this.patientIds = this.allPatientIdsMaster.filter(id => patientIdSet.has(id));
    } else {
      this.patientIds = [...this.allPatientIdsMaster];
    }

    // If totalRecords is provided from parent (server-side), use it. 
    // Otherwise fallback to local length (client-side only).
    if (this.totalRecords > 0) {
      this.totalPages = Math.ceil(this.totalRecords / this.paginationPageSize);
    } else {
      this.totalPages = Math.ceil(this.patientIds.length / this.paginationPageSize);
    }

    console.log(this.patientIds.length);

    // Sort events (Same as before)
    this.patientJourneyMap.forEach(events => {
      events.sort((a, b) => new Date(a.STATUS_DATE).getTime() - new Date(b.STATUS_DATE).getTime());
    });

    // --- 4. Build Hierarchy Structure (Without Colors yet) ---
    const hierarchyMap = new Map<string, Map<string, Map<string, Map<string, string>>>>();

    this.parentData.forEach(statusDim => {
      const referralName = statusDim.patient_status || 'Unknown';
      const groupName = statusDim.patient_status_group;
      const subGroupName = statusDim.patient_status_sub_group;
      const reasonCode = statusDim.patient_reason_code;
      const reasonDesc = statusDim.patient_reason_code_desc;

      if (!groupName || !subGroupName || !reasonCode) return;

      if (!hierarchyMap.has(referralName)) hierarchyMap.set(referralName, new Map());
      const groups = hierarchyMap.get(referralName)!;

      if (!groups.has(groupName)) groups.set(groupName, new Map());
      const subGroups = groups.get(groupName)!;

      if (!subGroups.has(subGroupName)) subGroups.set(subGroupName, new Map());
      const reasons = subGroups.get(subGroupName)!;

      reasons.set(reasonCode, reasonDesc);
    });

    // --- 5. Transform into Arrays ---
    this.statusHierarchy = Array.from(hierarchyMap.entries()).map(([referralName, groupsMap]) => {
      const groups = Array.from(groupsMap.entries()).map(([groupName, subGroupsMap]) => {
        const subGroups = Array.from(subGroupsMap.entries()).map(([subGroupName, reasonsMap]) => {
          const reasons = Array.from(reasonsMap.entries()).map(([reasonCode, reasonDesc]) => ({
            code: reasonCode,
            desc: reasonDesc,
            checked: false,
            color: '' // Placeholder, will be set in Step 6
          }));

          return {
            name: subGroupName,
            checked: false,
            indeterminate: false,
            isExpanded: false,
            color: '',
            reasons: reasons.sort((a, b) => a.desc.localeCompare(b.desc))
          };
        });

        return {
          name: groupName,
          checked: false,
          indeterminate: false,
          isExpanded: false,
          color: '',
          subGroups: subGroups.sort((a, b) => a.name.localeCompare(b.name))
        };
      });

      return {
        name: referralName,
        checked: false,
        indeterminate: false,
        isExpanded: false,
        color: '',
        groups: groups.sort((a, b) => a.name.localeCompare(b.name))
      };
    }).sort((a, b) => a.name.localeCompare(b.name));

    // --- 6. APPLY NEW COLOR STRATEGY ---
    this.applyDynamicColoring();

    // --- 7. Build Lookup Map ---
    this.reasonLookupMap.clear();
    this.statusHierarchy.forEach(referral => {
      referral.groups.forEach(group => {
        group.subGroups.forEach(subGroup => {
          subGroup.reasons.forEach(reason => {
            this.reasonLookupMap.set(reason.code, {
              color: reason.color,
              reasonRef: reason,
              subGroupRef: subGroup,
              parentGroupRef: group,
              referralRef: referral
            });
          });
        });
      });
    });
  }

  // --- NEW: Color Logic ---
  private applyDynamicColoring(): void {
    this.statusColorMap = {}; // Reset global map

    // 1. Generator for unique colors (skipping fixed colors)
    // Uses D3's Rainbow or Sinebow for maximum distinctness, 
    // or schemeTableau10 for distinct categories.
    const dynamicColorScale = d3.scaleOrdinal(d3.schemeTableau10);
    let dynamicColorIndex = 0;

    this.statusHierarchy.forEach(referralLayer => {
      const nameUpper = referralLayer.name.toUpperCase();
      let baseColor = FIXED_REFERRAL_COLORS[nameUpper];

      // If not a fixed color, generate a new one
      if (!baseColor) {
        // Ensure we don't accidentally pick a fixed color
        let candidate = dynamicColorScale(dynamicColorIndex.toString());
        while (Object.values(FIXED_REFERRAL_COLORS).includes(candidate)) {
          dynamicColorIndex++;
          candidate = dynamicColorScale(dynamicColorIndex.toString());
        }
        baseColor = candidate;
        dynamicColorIndex++;
      }

      // Set the top-level color
      referralLayer.color = baseColor;

      // Collect ALL reasons under this Referral Layer to calculate shades
      const allReasonsInReferral: StatusReason[] = [];
      referralLayer.groups.forEach(g => {
        g.color = baseColor; // Inherit base color
        g.subGroups.forEach(sg => {
          sg.color = baseColor; // Inherit base color
          sg.reasons.forEach(r => allReasonsInReferral.push(r));
        });
      });

      // Split reasons into "PS" codes and others
      const psReasons = allReasonsInReferral.filter(r => r.code.startsWith('PS'));
      const otherReasons = allReasonsInReferral.filter(r => !r.code.startsWith('PS'));

      // Apply Shading
      // 1. Normal reasons get the referral layer's base color
      this.applyShadesToReasons(baseColor, otherReasons);

      // 2. "PS" reasons get a fixed Purple base color
      // You can adjust this hex code to your preferred shade of purple
      const psBaseColor = '#9040ffff';
      this.applyShadesToReasons(psBaseColor, psReasons);
    });
  }




  private applyShadesToReasons(baseColor: string, reasons: StatusReason[]): void {
    const count = reasons.length;
    if (count === 0) return;

    if (count === 1) {
      reasons[0].color = baseColor;
      this.statusColorMap[reasons[0].code] = baseColor;
      return;
    }

    // --- FIX: Use d3.rgb() for robust parsing before L*a*b* conversion ---
    const baseRgb = d3.rgb(baseColor);
    const baseLab = d3.lab(baseRgb);

    if (!baseLab) {
      console.warn(`Failed to convert base color ${baseColor} to Lab.`);
      return;
    }
    // --- END FIX ---

    // Define a very small range for lightness variation (L component).
    const delta = 0.1;
    const baseL = baseLab.l;

    // Calculate the start and end lightness values for our interpolation.
    const startL = Math.max(0, baseL - (baseL * delta));
    const endL = Math.min(100, baseL + (baseL * delta));

    // Create a D3 scale to interpolate lightness
    const lightnessScale = d3.scaleLinear()
      .domain([0, count - 1])
      .range([startL, endL]);

    reasons.forEach((reason, index) => {
      const newL = lightnessScale(index);

      // Reconstruct color using the new lightness (L) and the original a and b components.
      const shadedColor = d3.lab(newL, baseLab.a, baseLab.b).formatHex();

      reason.color = shadedColor;
      this.statusColorMap[reason.code] = shadedColor;
    });
  }

  private processPageDataAndRender(): void {
    const startIndex = this.currentPage * this.paginationPageSize;
    const endIndex = startIndex + this.paginationPageSize;
    // 1. Get the patient IDs for the current page
    // In a real "fetch-on-demand" app, this list might just be
    // the 500 IDs you just fetched from the server.
    this.patientIdsForPage = this.patientIds.slice(startIndex, endIndex);
    console.log(`Page ${this.currentPage}: Loading ${this.patientIdsForPage.length} patients`);

    if (this.currentView === 'table') {
      this.prepareTableData();
      return;
    }

    // 2. *** NEW: Calculate layouts and pixel data for this page ***
    this.calculatePageLayoutsAndPixels(this.patientIdsForPage);

    // 3. Reset the view transform to the top-left corner
    this.viewTransform = { x: 0, y: 0, kx: 1, ky: 1 };

    // 4. Clear the X-brush
    if (this.brushSvg && this.brush) {
      const brushGroup = this.brushSvg.select<SVGGElement>('g.brush');
      if (!brushGroup.empty()) {
        brushGroup.call(this.brush.move, null);
      }
    }

    // 5. Clear the Y-brush
    if (this.yBrushSvg && this.yBrush) {
      const yBrushGroup = this.yBrushSvg.select<SVGGElement>('g.y-brush');
      if (!yBrushGroup.empty()) {
        yBrushGroup.call(this.yBrush.move, null);
      }
    }
    // NOTE: We no longer pan the Y-axis. We just reset it.

    // 6. Re-apply the current rule set if it exists (without immediate render)
    if (this.currentRuleSet) {
      this.applyRuleSet(this.currentRuleSet, false);
    }

    // 7. Render the map with the new paged data
    this.renderMain();
  }

  private calculatePageLayoutsAndPixels(patientIdsForPage: string[]): void {
    // 1. Create a temporary flat list of events *for this page*
    const allEventsForLayout: any[] = [];
    const toDateKey = d3.timeFormat("%Y-%m-%d");
    let tempRowIndex = 0;

    for (const patientId of patientIdsForPage) {
      const patientEvents = this.patientJourneyMap.get(patientId) || [];
      if (patientEvents.length === 0) continue;
      patientEvents.forEach(event => {
        const statusDate = new Date(event.STATUS_DATE);
        const initiatedDate = new Date(event.PATIENT_INITIATED_DATE);
        const diffDays = Math.floor((statusDate.getTime() - initiatedDate.getTime()) / (1000 * 60 * 60 * 24));
        allEventsForLayout.push({
          ...event,
          rowIndex: tempRowIndex,
          daysFromStart: diffDays,
          dateKey: toDateKey(statusDate)
        });
      });
      tempRowIndex++;
    }

    // 2. Calculate min/max for domains
    const [minDays, maxDays] = d3.extent(allEventsForLayout, d => d.daysFromStart) as [number, number];
    const [minDate, maxDate] = d3.extent(allEventsForLayout, d => new Date(d.STATUS_DATE)) as [Date, Date];

    // 3. Create Linear Scales (for this page)
    const baseWorldWidth = 10000; // Use a consistent base width for the scale's range
    if (minDays !== undefined && maxDays !== undefined) {
      // Add padding to the domain so the last day has space
      this.timeScaleLinear = d3.scaleLinear()
        .domain([minDays, (maxDays ?? minDays) + 1])
        .range([0, baseWorldWidth]);
    }
    if (minDate && maxDate) {
      // Add padding to the domain so the last day has space
      const nextDayAfterMax = new Date(maxDate.getTime());
      nextDayAfterMax.setDate(nextDayAfterMax.getDate() + 1);

      this.dateScaleLinear = d3.scaleUtc()
        .domain([minDate, nextDayAfterMax])
        .range([0, baseWorldWidth]);
    } else {
      // Fallback if no dates
      this.timeScaleLinear = d3.scaleLinear().domain([0, 1]).range([0, baseWorldWidth]);
      this.dateScaleLinear = d3.scaleUtc().domain([new Date(), new Date()]).range([0, baseWorldWidth]);
    }

    // 4. Create the final *page* PixelData with all coordinates
    this.allPixelData = [];
    let pageRowIndex = 0;
    
    // --- NEW: Track max events in a day for dynamic zoom ---
    let maxEventsInADay = 1;

    for (const patientId of patientIdsForPage) {
      const patientEvents = this.patientJourneyMap.get(patientId) || [];
      if (patientEvents.length === 0) continue;

      // --- START FIX: Pre-process patient events to add missing properties ---
      const processedPatientEvents = patientEvents.map(event => {
        const statusDate = new Date(event.STATUS_DATE);
        const initiatedDate = new Date(event.PATIENT_INITIATED_DATE);
        const diffDays = Math.floor((statusDate.getTime() - initiatedDate.getTime()) / (1000 * 60 * 60 * 24));
        const dateKey = toDateKey(statusDate);
        return {
          ...event,
          daysFromStart: diffDays,
          dateKey: dateKey
        };
      });
      // --- END FIX ---

      // --- Pre-calculate counts for this patient using processed events ---
      const dailyCountsForPatient = d3.rollup(processedPatientEvents, v => v.length, d => d.daysFromStart);
      const calendarCountsForPatient = d3.rollup(processedPatientEvents, v => v.length, d => d.dateKey);

      // Updates maxEventsInADay
      for (const count of dailyCountsForPatient.values()) {
        if (count > maxEventsInADay) maxEventsInADay = count;
      }
      for (const count of calendarCountsForPatient.values()) {
        if (count > maxEventsInADay) maxEventsInADay = count;
      }

      const dailySubDayIndices = new Map<number, number>();
      const calendarSubDayIndices = new Map<string, number>();

      // --- Iterate over the *processed* events ---
      processedPatientEvents.forEach((event, colIndex) => {
        // --- Now these properties exist ---
        const statusDate = new Date(event.STATUS_DATE);
        const diffDays = event.daysFromStart;
        const dateKey = event.dateKey;

        // --- Get and increment sub-day index ---
        const subDayIndex = dailySubDayIndices.get(diffDays) || 0;
        dailySubDayIndices.set(diffDays, subDayIndex + 1);

        const calendarSubDayIndex = calendarSubDayIndices.get(dateKey) || 0;
        calendarSubDayIndices.set(dateKey, calendarSubDayIndex + 1);

        // --- Base X positions (start of the day) ---
        const base_cx_linear_time = this.timeScaleLinear ? this.timeScaleLinear(diffDays) : undefined;
        const base_cx_linear_calendar = this.dateScaleLinear ? this.dateScaleLinear(statusDate) : undefined;

        // --- Calculate dynamic offset for 'time' view ---
        let cx_time_with_offset = base_cx_linear_time;
        if (base_cx_linear_time !== undefined && this.timeScaleLinear) {
          const countForDay = dailyCountsForPatient.get(diffDays) || 1;
          if (countForDay > 1) {
            const nextDayX = this.timeScaleLinear(diffDays + 1);
            const worldSpaceForDay = nextDayX - base_cx_linear_time;
            // Divide the day's space by the number of events
            // Add a small inner padding (0.1) so they don't touch the grid lines
            const innerPadding = worldSpaceForDay * 0.1;
            const usableSpace = worldSpaceForDay - (innerPadding * 2);
            const dynamicOffset = (usableSpace / (countForDay - 1)) * subDayIndex;
            cx_time_with_offset = base_cx_linear_time + innerPadding + dynamicOffset;
          }
        }

        // --- Calculate dynamic offset for 'calendar' view ---
        let cx_calendar_with_offset = base_cx_linear_calendar;
        if (base_cx_linear_calendar !== undefined && this.dateScaleLinear) {
          const countForDay = calendarCountsForPatient.get(dateKey) || 1;
          if (countForDay > 1) {
            const nextDay = new Date(statusDate.getTime());
            nextDay.setDate(nextDay.getDate() + 1);
            const nextDayX = this.dateScaleLinear(nextDay);
            const worldSpaceForDay = nextDayX - base_cx_linear_calendar;
            // Divide the day's space by the number of events
            // Add a small inner padding (0.1) so they don't touch the grid lines
            const innerPadding = worldSpaceForDay * 0.1;
            const usableSpace = worldSpaceForDay - (innerPadding * 2);
            const dynamicOffset = (usableSpace / (countForDay - 1)) * calendarSubDayIndex;
            cx_calendar_with_offset = base_cx_linear_calendar + innerPadding + dynamicOffset;
          }
        }

        this.allPixelData.push({
          ...event,
          rowIndex: pageRowIndex,
          colIndex: colIndex,
          daysFromStart: diffDays,
          uniqueId: `${patientId}-${colIndex}`,
          subDayIndex: subDayIndex,
          calendarSubDayIndex: calendarSubDayIndex,

          cx_standard: (colIndex * 12) + (12 / 2),

          cx_linear_time: cx_time_with_offset,
          cx_linear_calendar: cx_calendar_with_offset
        });
      });
      pageRowIndex++;
    }

    const pixelsByRow = d3.group(this.allPixelData, d => d.rowIndex);

    pixelsByRow.forEach(rowPixels => {
      for (let i = 0; i < rowPixels.length - 1; i++) {
        const current = rowPixels[i];
        const next = rowPixels[i + 1];
        current.next_cx_linear_time = next.cx_linear_time;
        current.next_cx_linear_calendar = next.cx_linear_calendar;
      }
    });

    // --- 5. Calculate Dynamic Zoom Limits ---
    // minZoom: Fit the ACTUAL world into the canvas
    const canvasWidth = this.mainCanvas ? this.mainCanvas.clientWidth : 1000;
    
    // Calculate Actual Data Width to set minZoom correctly.
    // Use a safe minimum (1000) so we don't zoom strangely on empty data.
    const padding = 100;
    let currentDataWidth = 0;
    if (this.currentView === 'standard') {
        currentDataWidth = (d3.max(this.allPixelData, d => d.cx_standard) || 0) + padding;
    } else if (this.currentView === 'time') {
        currentDataWidth = (d3.max(this.allPixelData, d => d.cx_linear_time) || 0) + padding;
    } else {
        currentDataWidth = (d3.max(this.allPixelData, d => d.cx_linear_calendar) || 0) + padding;
    }
    const worldWidth = Math.max(canvasWidth, currentDataWidth, 1000);

    this.minZoom = Math.max(0.001, canvasWidth / worldWidth);

    // maxZoom: Ensure we can resolve individual events
    // Formula: (worldWidth / totalDays) * kx / maxEventsInADay >= targetPixelWidth
    // kx >= (targetPixelWidth * maxEventsInADay * totalDays) / worldWidth
    const targetPixelWidth = 20; 
    let totalDays = 1;
    if (this.currentView === 'calendar' && this.dateScaleLinear) {
      const domain = this.dateScaleLinear.domain();
      const msDiff = domain[1].getTime() - domain[0].getTime();
      totalDays = Math.max(1, msDiff / (1000 * 60 * 60 * 24));
    } else if (this.currentView === 'time' && this.timeScaleLinear) {
      const domain = this.timeScaleLinear.domain();
      totalDays = Math.max(1, (domain[1] - domain[0]));
    }
    // Formula: (worldWidth / totalDays) * kx / maxEventsInADay >= targetPixelWidth
    // kx >= (targetPixelWidth * maxEventsInADay * totalDays) / worldWidth
    const calculatedMaxByEvents = (targetPixelWidth * maxEventsInADay * totalDays) / worldWidth;

    // --- NEW: Guarantee Single Day Granularity ---
    // User requirement: "Our max zoom should always get us to a point where we show singular days."
    // `getVisibleTickData` requires > 40px per day to show single day ticks.
    // We target 60px per day to be safe and clear.
    // PxPerDay = TotalPixels / TotalDays = (WorldWidth * kx) / TotalDays
    // 60 = (WorldWidth * kx) / TotalDays
    // kx = (60 * TotalDays) / WorldWidth
    const minPxPerDay = 60;
    const calculatedMaxByTicks = (minPxPerDay * totalDays) / worldWidth;

    // The data-driven max zoom is the greater of "seeing events" or "seeing days".
    const calculatedMax = Math.max(calculatedMaxByEvents, calculatedMaxByTicks);

    // --- FIX: Strictly Align Max Zoom with Physical Brush Limit ---
    // The brush has a minimum gap of 20px (minBrushGap).
    const margin = this.margin.left + this.margin.right;
    const brushComponentPadding = 20; 
    const rawBrushWidth = Math.max(100, canvasWidth - margin);
    const effectiveBrushTrackWidth = rawBrushWidth - brushComponentPadding;
    
    const minBrushGap = 20;
    const physicalMaxZoom = this.minZoom * (effectiveBrushTrackWidth / minBrushGap);
    
    // 3. Set maxZoom. 
    // We prioritize the physical limit so interaction feels correct.
    // We expect physicalMaxZoom to be significantly higher now that worldWidth is tighter.
    this.maxZoom = Math.max(20, physicalMaxZoom, calculatedMax);
    
    console.log(`[PixelMap] Dynamic Zoom - WorldWidth: ${worldWidth.toFixed(0)}, MinZoom: ${this.minZoom.toFixed(4)}, MaxZoom: ${this.maxZoom.toFixed(2)} (Phys: ${physicalMaxZoom.toFixed(2)})`);

    // Store calculated widths
    this.standardViewDataWidth = worldWidth;
    this.timeViewDataWidth = currentDataWidth;
    this.calendarViewDataWidth = currentDataWidth;

    // 6. No sorted layouts needed
    this.timeLayoutSorted = [];
    this.calendarLayoutSorted = [];

  }


  public toggleStatusByDoubleClick(node: PixelData): void {
    // 1. Ensure we are in analytical mode and the draft state is ready.
    this.setAnalyticalMode(true);

    // Find the specific reason and its parents in the master hierarchy list
    const parentGroup = this.analyticalHierarchyState.find(g => g.name === node.STATUS_GROUP);
    if (!parentGroup) return;

    const subGroup = parentGroup.subGroups.find(sg => sg.name === node.STATUS_SUB_GROUP);
    if (!subGroup) return;

    const reason = subGroup.reasons.find(r => r.code === node.STATUS_REASON_CODE);
    if (!reason) return;

    // Step 1: Toggle the 'checked' state of the specific reason
    reason.checked = !reason.checked;

    this.updateLegendData();

    // Step 2: Update the parent and grandparent states
    this.updateSubGroupCheckbox(subGroup);
    this.updateParentCheckbox(parentGroup);

    // Step 3: Trigger a redraw of the canvas to show the change
    this.renderMain();
    this.cdr.detectChanges(); // notify angular that stuff has changed
  }

  /**
 * Updates a sub-group's checked/indeterminate state based on its children.
 */
  private updateSubGroupCheckbox(subGroup: SubStatusGroup): void {
    const allChecked = subGroup.reasons.every(r => r.checked);
    const noneChecked = subGroup.reasons.every(r => !r.checked);
    subGroup.checked = allChecked;
    subGroup.indeterminate = !allChecked && !noneChecked;
  }

  /**
   * Updates a parent group's checked/indeterminate state based on its sub-groups.
   */
  private updateParentCheckbox(group: StatusGroup): void {
    const allChildrenChecked = group.subGroups.every(sg => sg.checked && !sg.indeterminate);
    const noChildrenChecked = group.subGroups.every(sg => !sg.checked && !sg.indeterminate);

    if (allChildrenChecked) {
      group.checked = true;
      group.indeterminate = false;
    } else if (noChildrenChecked) {
      group.checked = false;
      group.indeterminate = false;
    } else {
      group.checked = false;
      group.indeterminate = true;
    }
  }

  public updateLegendData(): void {
    // if (!this.useAnalyticalMode || !this.analyticalHierarchyState) {
    //     this.legendItems = [];
    //     this.totalSelectedStatuses = 0;
    //     this.totalUniquePatients = 0;
    //     this.cdr.detectChanges();
    //     return;
    // }

    // 1. Find all reason objects that are currently checked OR part of the active query
    const checkedReasons = this.analyticalHierarchyState
      .flatMap(referral => referral.groups)
      .flatMap(group => group.subGroups)
      .flatMap(subGroup => subGroup.reasons)
      .filter(reason => reason.checked);

    const queryReasons: StatusReason[] = [];
    if (this.currentRuleSet) {
        // Helper to extract reasons from a rule
        const extractReasons = (rule: Rule) => {
            if (rule.field === 'STATUS_REASON_CODE') {
                if (rule.operator === 'is one of' && Array.isArray(rule.value)) {
                    (rule.value as StatusReason[]).forEach(r => queryReasons.push(r));
                } else if (rule.operator === 'duration between') {
                    rule.startStatus?.forEach(r => queryReasons.push(r));
                    rule.endStatus?.forEach(r => queryReasons.push(r));
                }
            }
        };

        const traverse = (item: Rule | RuleSet) => {
            if (item.type === 'ruleset') {
                (item as RuleSet).rules.forEach(traverse);
            } else {
                extractReasons(item as Rule);
            }
        };
        traverse(this.currentRuleSet);
    }

    // Combine and deduplicate
    const combinedReasons = [...checkedReasons];
    queryReasons.forEach(qr => {
        if (!combinedReasons.some(cr => cr.code === qr.code)) {
            // Find the full reason object in the hierarchy to get color/desc if needed
            // Or just use the one from the query if it has enough info.
            // Better to find it in the hierarchy to ensure consistency.
            const lookup = this.analyticalReasonLookupMap.get(qr.code);
            if (lookup) {
                combinedReasons.push(lookup.reasonRef);
            }
        }
    });
    
    const selectedReasons = combinedReasons;

    // 2. For each checked reason, calculate its specific stats
    const newLegendItems: LegendStatusItem[] = selectedReasons.map(reason => {
      const pointsForThisStatus = this.allPixelData.filter(p => p.STATUS_REASON_CODE === reason.code);
      const uniquePatientsForThisStatus = new Set(pointsForThisStatus.map(p => p.LH_PATIENT_ID));

      return {
        code: reason.code,
        desc: reason.desc,
        color: reason.color,
        totalPoints: pointsForThisStatus.length,
        uniquePatients: uniquePatientsForThisStatus.size
      };
    });

    // 3. Update the component property that the template uses
    this.legendItems = newLegendItems;

    // 4. Calculate the overall summary stats
    this.totalSelectedStatuses = this.legendItems.length;
    this.totalPoints = this.legendItems.reduce((sum, item) => sum + item.totalPoints, 0);

    // To get the total unique patients, and total points, we must combine them all into a Set
    const totalPatientSet = new Set<string>();
    const selectedCodes = new Set(this.legendItems.map(item => item.code));
    for (const pixel of this.allPixelData) {
      if (selectedCodes.has(pixel.STATUS_REASON_CODE)) {
        totalPatientSet.add(pixel.LH_PATIENT_ID);
      }
    }
    this.totalUniquePatients = totalPatientSet.size;

    this.cdr.detectChanges(); // Notify Angular of all changes
  }

  /**
   * Build a Map<rowIndex, PixelData[]> for fast retrieval of visible rows
   */
  private buildRowIndexMap(allPixelData: PixelData[]) {
    const map = new Map<number, PixelData[]>();
    for (const p of allPixelData) {
      const arr = map.get(p.rowIndex) || [];
      arr.push(p);
      map.set(p.rowIndex, arr);
    }
    return map;
  }

  /**
   * Call this when switching views from outside
   */
  public animateCanvasToView(view: 'standard' | 'calendar' | 'time') {
    const ctl = (this as any).__canvasAnimationController;
    if (ctl && ctl.animateTo) ctl.animateTo(view);
  }

  private showTooltip(event: MouseEvent, cluster: Cluster, tooltip: any): void {
    // 0. Check for Drag/Pan
    if (this.isPanning || this.isDragging) {
      this.hideTooltip(tooltip);
      return;
    }

    // 1. Set Data
    if (cluster.isCluster) {
      this.tooltipData = {
        isCluster: true,
        count: cluster.count,
        pixels: cluster.pixels,
        ...cluster.pixels[0]
      };
    } else {
      this.tooltipData = {
        isCluster: false,
        count: 1,
        ...cluster.pixels[0]
      };
    }
    this.tooltipVisible = true;
    this.cdr.detectChanges();

    // 2. Get Tooltip Dimensions
    const tooltipNode = tooltip.node() as HTMLElement;
    if (!tooltipNode) return;

    // Measure the inner content because the wrapper might not have size yet or is just a container
    const innerTooltip = tooltipNode.querySelector('.chart_tooltip') as HTMLElement;
    const tW = innerTooltip ? innerTooltip.offsetWidth : tooltipNode.offsetWidth;
    const tH = innerTooltip ? innerTooltip.offsetHeight : tooltipNode.offsetHeight;

    // 3. Determine Context & Coordinates
    let mouseX, mouseY, boundW, boundH, positionType;
    let offsetX = 0;
    let offsetY = 0;

    if (this.isFullscreen) {
      // --- FULLSCREEN MODE ---
      mouseX = event.clientX;
      mouseY = event.clientY;
      boundW = window.innerWidth;
      boundH = window.innerHeight;
      positionType = 'fixed';
    } else {
      // --- NORMAL MODE ---
      // D3 pointer automatically calculates x/y relative to the container's 0,0
      const container = this.hostElement.querySelector('.chart-container') as HTMLElement;
      [mouseX, mouseY] = d3.pointer(event, container);

      // Calculate offset of the container relative to the tooltip's positioning context
      const containerRect = container.getBoundingClientRect();
      const offsetParent = tooltipNode.offsetParent as HTMLElement || document.body;
      const parentRect = offsetParent.getBoundingClientRect();

      offsetX = containerRect.left - parentRect.left;
      offsetY = containerRect.top - parentRect.top;

      boundW = container.clientWidth;
      boundH = container.clientHeight;
      positionType = 'absolute';
    }

    // 4. Smart Position Logic
    const gap = 30;

    // --- Horizontal ---
    let left = mouseX + gap;
    // If it overflows right, flip left
    if (left + tW > boundW) {
      left = mouseX - gap - tW;
      // If it now overflows left (too wide), clamp to 0
      left = Math.max(0, left);
    }

    // --- Vertical (The Fix for "Sticking") ---
    let top = mouseY + gap;
    const spaceBelow = boundH - (mouseY + gap);

    // Check if it fits below
    if (tH > spaceBelow) {
      // It doesn't fit below, so try above
      top = mouseY - gap - tH;

      // If it goes off the top, clamp it to 0
      if (top < 0) {
        top = 0;
      }
    }
    // Otherwise, it fits below, so keep 'top' as is.
    // (Optional: clamp to bottom edge if you want to be super safe, 
    // but usually if tH < spaceBelow it's fine).

    // 5. Apply Styles
    // Apply the offset to the final position
    left += offsetX;
    top += offsetY;

    tooltip
      .style('visibility', 'visible')
      .style('position', positionType)
      .style('left', `${left}px`)
      .style('top', `${top}px`)
      .style('z-index', '10000')
      .style('right', null)
      .style('bottom', null);
  }

  private hideTooltip(tooltip: any): void {
    this.tooltipVisible = false;
    this.tooltipData = null;
    tooltip.style('visibility', 'hidden');
  }

  // --- MODIFIED: Uses fast Map.get() instead of slow .find() ---
  private statusColorMapColorFn(d: PixelData): string {
    const lookupMap = this.useAnalyticalMode ? this.analyticalReasonLookupMap : this.reasonLookupMap;
    const lookup = lookupMap.get(d.STATUS_REASON_CODE);

    if (!lookup) return this.greyscaleColor;

    // Extract the stored references
    const { color, reasonRef, subGroupRef, parentGroupRef, referralRef } = lookup;

    // If we are dragging, ensure every circle on the highlighted row keeps its original color.
    // This prevents the grey-out effect from hiding the blue row highlight.
    if (this.isDragging && this.dragStartNode && d.rowIndex === this.dragStartNode.rowIndex) {
      return color;
    }

    if (this.useAnalyticalMode) {
      // Check chain: Referral -> Group -> SubGroup -> Reason
      // If ANY parent in the chain is checked, this node is "active"
      const isChecked =
        (referralRef && referralRef.checked) || // Check top layer
        parentGroupRef.checked ||
        subGroupRef.checked ||
        reasonRef.checked;

      if (isChecked) {
        return color;
      }

      // If NOT manually checked, fall back to the query check
      // Only pixels that meet the condition are colored.
      if (this.currentRuleSet && this.currentRuleSet.rules.length > 0) {
        if (d.isConditionMet) {
          return color;
        }
      }

      return this.greyscaleColor;
    }

    return color;
  }
  /** 
   * Will set the analytical mode to true or false if provided an argument
   * but will just toggle the value of useAnalyticalMode if no argument is provided
   */

  public setAnalyticalMode(state?: boolean): void {
    const newState = state !== undefined ? state : !this.useAnalyticalMode;

    if (newState === this.useAnalyticalMode) {
      // No change needed, just return early
      return;
    }

    this.useAnalyticalMode = newState;

    if (this.useAnalyticalMode) {
      if (!this.analyticalHierarchyState || this.analyticalHierarchyState.length === 0) {
        console.log('Creating fresh draft state...');
        this.analyticalHierarchyState = this.cloneHierarchy(this.statusHierarchy);
      }

      // --- FIX: Use the helper function ---
      this.buildAnalyticalMap();
      // --- END FIX ---

    } else {
      console.log('Exiting Analytical Mode');
      // --- FIX: DO NOT clear the analytical state so we can toggle back on ---
      // this.analyticalHierarchyState = [];
      // this.analyticalReasonLookupMap.clear();
      this.updateLegendData();
    }

    // Trigger redraw if available
    this.renderMain();
  }


  /**
 * Rebuilds the analyticalReasonLookupMap from the current analyticalHierarchyState.
 */
  /**
   * Rebuilds the analyticalReasonLookupMap from the current analyticalHierarchyState.
   * UPDATED: Now handles 4 layers (Referral -> Group -> SubGroup -> Reason)
   */
  private buildAnalyticalMap(): void {
    if (!this.analyticalHierarchyState || this.analyticalHierarchyState.length === 0) {
      return;
    }

    this.analyticalReasonLookupMap.clear();

    // 1. Loop through Referral Layers
    this.analyticalHierarchyState.forEach(referral => {
      // 2. Loop through Groups
      referral.groups.forEach(group => {
        // 3. Loop through SubGroups
        group.subGroups.forEach(subGroup => {
          // 4. Loop through Reasons
          subGroup.reasons.forEach(reason => {

            // Map the Reason Code to the styling/reference data
            this.analyticalReasonLookupMap.set(reason.code, {
              color: reason.color,
              reasonRef: reason,
              subGroupRef: subGroup,
              parentGroupRef: group,
              referralRef: referral // <--- Store the reference
            });
          });
        });
      });
    });
  }

  public toggleVisibleDataLock(): void {
    const scrollContainer = this.pixelMapContainer.nativeElement;

    // IF we are about to LOCK the view...
    if (!this.isLockedToVisible) {
      // ...SAVE the current scroll position BEFORE we do anything else.
      this.lastScrollTop = scrollContainer.scrollTop;
    }
    // Toggle the lock state
    this.isLockedToVisible = !this.isLockedToVisible;

    // A full re-render is the cleanest way to apply the change.
    // The updatePixelMap function will handle the rest based on the new isLockedToVisible state.
    this.renderMain();

    // IF we have just UNLOCKED the view...
    if (!this.isLockedToVisible) {
      // ...RESTORE the scroll position AFTER the chart has been re-rendered.
      // A small timeout ensures the browser has time to process the re-render.
      setTimeout(() => {
        scrollContainer.scrollTop = this.lastScrollTop;
      }, 100);
    }
  }

  // Add this new public method to your class
  // TODO: needs to be to just toggle Y axis!!!
  public togglePatientIDs(forceValue?: boolean): void {
    this.showPatientIDs =
      typeof forceValue === 'boolean' ? forceValue : !this.showPatientIDs;

    this.renderMain();
  }
  public toggleExtendBlocks(): void {
    this.extendBlocks = !this.extendBlocks;
    this.renderMain(); // Re-draw the chart with the new setting
  }

  public nextPage(): void {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.pageChange.emit(this.currentPage);
      this.processPageDataAndRender();
    }
  }

  public previousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.pageChange.emit(this.currentPage);
      this.processPageDataAndRender();
    }
  }

  public onPageSizeChanged(res: any) {
    this.paginationPageSize = res;
    this.pageSizeChange.emit(res);
    this.processPageDataAndRender();
  }

  // ADD these new methods for pan and zoom to your class

  public onCanvasMouseDown(event: MouseEvent): void {
    this.stopAnimation(); // --- MODIFIED: Uses new, non-jumping stop ---
    this.isPanning = true;
    this.lastPanPosition = { x: event.clientX, y: event.clientY };
    this.mainCanvas.style.cursor = 'grabbing';
  }

  public onCanvasMouseUp(event: MouseEvent): void {
    this.isPanning = false;
    this.mainCanvas.style.cursor = 'default';

    const currentTime = new Date().getTime();
    const timeDiff = currentTime - this.lastClickTime;

    if (timeDiff < this.doubleClickThreshold) {
      // Double click detected
      const foundCluster = this.findClusterAt(event);
      if (foundCluster && foundCluster.pixels.length > 0) {
        const code = foundCluster.pixels[0].STATUS_REASON_CODE;
        this.toggleReasonSelection(code);
        this.updateLegendData();
      }
    }

    this.lastClickTime = currentTime;
  }

  /**
   * Toggles the selection of a status reason in the analytical hierarchy.
   * This effectively "adds" it to the analyticalReasonLookupMap.
   */
  private toggleReasonSelection(code: string): void {
    // Ensure we have a hierarchy state to work with
    if (!this.analyticalHierarchyState || this.analyticalHierarchyState.length === 0) {
      // If no state exists, we might need to clone the base hierarchy
      // or if we are not in analytical mode, maybe we should switch?
      // For now, let's assume we want to modify the *active* hierarchy if in analytical mode,
      // or the *draft* hierarchy if we are about to switch.
      // But the user said "add it into my analyticalReasonLookupMap".

      // If we are NOT in analytical mode, we should probably initialize the state from the current statusHierarchy
      if (!this.useAnalyticalMode) {
        this.analyticalHierarchyState = this.cloneHierarchy(this.statusHierarchy);
      }
    }

    // Find the reason in the hierarchy
    let found = false;
    for (const referral of this.analyticalHierarchyState) {
      for (const group of referral.groups) {
        for (const subGroup of group.subGroups) {
          const reason = subGroup.reasons.find(r => r.code === code);
          if (reason) {
            reason.checked = !reason.checked; // "Add it" implies selecting it.
            // We should also ensure parent groups are checked/indeterminate if needed, 
            // but for now let's just check the reason.
            // Actually, if we want it to show up, we might need to ensure parents are expanded or checked?
            // The `statusColorMapColorFn` checks: (referralRef.checked || parentGroupRef.checked || subGroupRef.checked || reasonRef.checked)
            // So checking the reason is enough.
            found = true;
            break;
          }
        }
        if (found) break;
      }
      if (found) break;
    }

    if (found) {
      // Rebuild the map to reflect changes
      this.buildAnalyticalMap();

      // If not in analytical mode, maybe we should switch?
      // The user said "Basically take what my manage-status tab does without having to open the dialog."
      // The dialog modifies the state.
      // If we want to SEE the result, we probably need to be in Analytical Mode.
      if (!this.useAnalyticalMode) {
        this.setAnalyticalMode(true);
      } else {
        this.renderMain();
      }
    }
  }

  public onCanvasMouseLeave(): void {
    this.isPanning = false;
    this.mainCanvas.style.cursor = 'default';
    this.hideTooltip(d3.select("#d3WordCloudTooltip"));

    if (this.hoverState) {
      this.hoverState = null;
      // Redraw to clear crosshairs and labels
      this.updateCrosshairs();
      this.drawHoverXAxisLabel();
      if (!this.showPatientIDs) {
        this.drawHoverYAxisLabel();
      }
      this.drawHighlight(); // Clear the highlight canvas
      this.updateYAxisHover(); // Clear Y-axis hover state
    }
  }


  /**
 * Helper to find the cluster under the mouse cursor.
 * Reused by onCanvasMouseMove (hover) and onCanvasMouseUp (click/double-click).
 */
  private findClusterAt(event: MouseEvent): Cluster | null {
    const yScale = this.viewTransform.ky;
    const mouseX = event.offsetX;
    const mouseY = event.offsetY;

    const worldX = (mouseX - this.viewTransform.x) / this.viewTransform.kx;
    const worldY = (mouseY - this.viewTransform.y) / yScale;

    const rowHeight = this.rowHeight;
    const rowIndex = Math.floor(worldY / rowHeight);
    const patientEvents = this.allPixelData.filter(p => p.rowIndex === rowIndex);

    if (this.currentView === 'standard') {
      const cellSize = 12;
      const colIndex = Math.floor(worldX / cellSize);
      const foundPoint = patientEvents.find(p => p.colIndex === colIndex) || null;
      if (foundPoint) {
        return {
          pixels: [foundPoint],
          worldX: foundPoint.cx_standard!,
          worldY: (foundPoint.rowIndex * rowHeight) + (rowHeight / 2),
          screenX: 0, count: 1, isCluster: false
        };
      }
    } else if (this.currentView === 'calendar' || this.currentView === 'time') {

      // --- START MODIFIED LOGIC FOR EXTEND BLOCKS ---
      // 1. Build the clusters first, just like the draw function
      const clusters = this.buildRowClusters(patientEvents, this.currentView, rowHeight);

      if (this.extendBlocks) {
        const verticalPaddingFraction = 0.1;
        const worldHorizontalPadding = 0.3;

        return clusters.find(cluster => {
          const firstPixel = cluster.pixels[0];

          // 2. Check Padded Y
          const y = firstPixel.rowIndex * rowHeight;
          const h = rowHeight;
          const paddedY = y + (h * verticalPaddingFraction);
          const paddedH = h * (1 - (verticalPaddingFraction * 2));
          if (worldY < paddedY || worldY > (paddedY + paddedH)) return false;

          // 3. Check Padded X
          const startX = (this.currentView === 'calendar' ? firstPixel.cx_linear_calendar : firstPixel.cx_linear_time);
          const getEndX = (p: PixelData) => {
            const next_cx = (this.currentView === 'calendar' ? p.next_cx_linear_calendar : p.next_cx_linear_time);
            const cx = (this.currentView === 'calendar' ? p.cx_linear_calendar : p.cx_linear_time);
            if (next_cx !== undefined) return next_cx;
            if (cx !== undefined) return cx + (this.constantPixelSize / this.viewTransform.kx);
            return 0;
          };
          const endX = d3.max(cluster.pixels, getEndX);
          if (startX === undefined || endX === undefined) return false;

          const w = endX - startX;
          const paddedX = startX + worldHorizontalPadding;
          const paddedW = w - (worldHorizontalPadding * 2);
          if (paddedW <= 0) return false;

          return worldX >= paddedX && worldX <= (paddedX + paddedW);
        }) || null;

      } else {
        // --- 4. Hit-test for CLUSTERED points (circles/squares) ---
        return clusters.find(cluster => {
          if (cluster.isCluster) {
            const screenRadius = 8;
            const worldRadiusX = screenRadius / this.viewTransform.kx;
            const worldRadiusY = screenRadius / this.viewTransform.ky;
            return (Math.pow(worldX - cluster.worldX, 2) / Math.pow(worldRadiusX, 2)) +
              (Math.pow(worldY - cluster.worldY, 2) / Math.pow(worldRadiusY, 2)) <= 1;
          } else {
            const worldPixelWidth = this.constantPixelSize / this.viewTransform.kx;
            const worldPixelHeight = this.constantPixelSize / this.viewTransform.ky;
            const linearX = cluster.worldX - (worldPixelWidth / 2);
            const linearW = worldPixelWidth;
            const linearY = cluster.worldY - (worldPixelHeight / 2);
            const linearH = worldPixelHeight;
            if (worldY < linearY || worldY > (linearY + linearH)) return false;
            return worldX >= linearX && worldX <= (linearX + linearW);
          }
        }) || null;
      }
    }
    return null;
  }

  public onCanvasMouseMove(event: MouseEvent): void {
    if (this.isPanning) {
      this.hideTooltip(d3.select("#d3WordCloudTooltip"));
      const dx = event.clientX - this.lastPanPosition.x;
      const dy = event.clientY - this.lastPanPosition.y;
      this.viewTransform.x += dx;
      this.viewTransform.y += dy;
      this.clampTransform();
      this.lastPanPosition = { x: event.clientX, y: event.clientY };
      this.renderMain();
      return;
    }

    const foundCluster = this.findClusterAt(event);

    const oldHoverId = this.hoverState?.uniqueId;
    let newHoverId: string | null = null;

    if (foundCluster) {
      const firstPixel = foundCluster.pixels[0];
      newHoverId = `${firstPixel.rowIndex}-${foundCluster.worldX}`;

      this.showTooltip(event, foundCluster, d3.select("#d3WordCloudTooltip"));

      let xLabel = '';
      if (this.currentView === 'calendar') {
        xLabel = d3.timeFormat('%Y-%m-%d')(new Date(firstPixel.STATUS_DATE));
      } else if (this.currentView === 'time') {
        const days = (firstPixel as any).daysFromStart;
        xLabel = days !== undefined ? `Day ${days}` : 'N/A';
      }

      // --- Find center for crosshair ---
      let screenX, screenY;
      screenY = foundCluster.worldY * this.viewTransform.ky + this.viewTransform.y;

      if (this.currentView !== 'standard' && this.extendBlocks) {
        // Find center of the *aggregated* extended block
        const startX = (this.currentView === 'calendar' ? firstPixel.cx_linear_calendar : firstPixel.cx_linear_time);
        const getEndX = (p: PixelData) => {
          const next_cx = (this.currentView === 'calendar' ? p.next_cx_linear_calendar : p.next_cx_linear_time);
          const cx = (this.currentView === 'calendar' ? p.cx_linear_calendar : p.cx_linear_time);
          if (next_cx !== undefined) return next_cx;
          if (cx !== undefined) return cx + (this.constantPixelSize / this.viewTransform.kx);
          return 0;
        };
        const endX = d3.max(foundCluster.pixels, getEndX);
        const worldHorizontalPadding = 0.1;
        const paddedX = startX + worldHorizontalPadding;
        const paddedW = (endX - startX) - (worldHorizontalPadding * 2);
        const worldX_center = paddedX + (paddedW / 2);
        screenX = worldX_center * this.viewTransform.kx + this.viewTransform.x;
      } else {
        // Center is just the cluster's worldX
        screenX = foundCluster.worldX * this.viewTransform.kx + this.viewTransform.x;
      }

      this.hoverState = {
        hoverId: newHoverId,
        screenX: screenX,
        screenY: screenY,
        patientId: firstPixel.LH_PATIENT_ID,
        xLabel: xLabel,
        isCluster: foundCluster.count > 1, // Use count > 1
        hoveredData: foundCluster.pixels
      };
    } else {
      this.hideTooltip(d3.select("#d3WordCloudTooltip"));
      this.hoverState = null;
    }

    if (oldHoverId !== newHoverId) {
      this.drawHighlight();
      this.updateYAxisHover(); // Update Y-axis labels
    }

    this.updateCrosshairs();
    this.drawHoverXAxisLabel();
    if(!this.showPatientIDs){
      this.drawHoverYAxisLabel();
    }
  }

  /**
   * REWRITTEN: This is now the main entry point for all rendering.
   * It recalculates coordinates, resizes canvases, applies the camera transform,
   * and calls the appropriate drawing functions for the current view.
   */
  public renderMain(): void {
    if (!this.mainCtx) return;

    // --- 2. Calculate "World" Dimensions ---
    const rowHeight = this.rowHeight;
    let totalWidth = 0;
    let totalHeight = this.patientIdsForPage.length * rowHeight;

    switch (this.currentView) {
      case 'standard':
        totalWidth = this.standardViewDataWidth;
        break;
      case 'calendar':
        totalWidth = this.calendarViewDataWidth;
        break;
      case 'time':
        totalWidth = this.timeViewDataWidth;
        break;
    }
    this.currentDimensions = { width: totalWidth, height: totalHeight };

    // --- 3. Resize Canvases ---
    const dpr = window.devicePixelRatio || 1;
    const yAxisLabelWidth = this.showPatientIDs ? this.yAxisWidth : 0;
    const containerNode = this.hostElement.querySelector('.chart-container') as HTMLElement;
    const mainViewportWidth = containerNode.clientWidth - yAxisLabelWidth;
    const viewportHeight = containerNode.clientHeight - this.brushHeight - this.headerHeight;

    [this.mainCanvas, this.pickingCanvas, this.highlightCanvas].forEach(canvas => {
      canvas.width = mainViewportWidth * dpr;
      canvas.height = viewportHeight * dpr;
      canvas.style.width = `${mainViewportWidth}px`;
      canvas.style.height = `${viewportHeight}px`;
    });
    // Draw crosshairs
    if (this.crosshairSvg) {
      this.crosshairSvg
        .attr('width', mainViewportWidth)
        .attr('height', viewportHeight);
    }

    // --- 4. Clear All Contexts ---
    [this.mainCtx, this.pickingCtx].forEach(ctx => {
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    });

    // --- 5. Get Tick Data ---
    const tickData = this.getVisibleTickData();
    // --- 6. Draw SVG Header & Y-Axis ---
    this.drawHeader(tickData); // Pass tickData to the header
    this.drawYAxis(rowHeight, yAxisLabelWidth, this.headerHeight);

    if(!this.showPatientIDs){
      this.drawHoverYAxisLabel();
    }
    this.drawHoverXAxisLabel();

    // --- 7. Apply Camera Transform ---
    const yScale = this.viewTransform.ky;
    [this.mainCtx, this.pickingCtx].forEach(ctx => {
      ctx.save();
      ctx.translate(0, 0);
      ctx.translate(this.viewTransform.x, this.viewTransform.y);
      ctx.scale(this.viewTransform.kx, yScale);
    });

    // --- 8. DRAW GRID LINES (Underneath data) ---
    this.drawGridLines(tickData, totalHeight);

    // --- 9. Calculate Visible Area (Culling) ---
    const visibleTop = -this.viewTransform.y / yScale;
    const visibleBottom = visibleTop + (viewportHeight) / yScale; // Use viewportHeight
    const visibleLeft = -this.viewTransform.x / this.viewTransform.kx;
    const visibleRight = visibleLeft + this.mainCanvas.clientWidth / this.viewTransform.kx;

    if (this.allPixelData.length === 0) {
      [this.mainCtx, this.pickingCtx].forEach(ctx => ctx.restore());
      return;
    }

    const visibleData = this.allPixelData.filter(d => {
      const y = d.rowIndex * rowHeight;
      return y + rowHeight >= visibleTop && y <= visibleBottom;
    });

    // --- START: MODIFIED STEP 10 (SINGLE-PASS RENDER) ---
    // 10a. Get non-hovered data
    const hoveredUniqueId = this.hoverState?.uniqueId;
    const nonHoveredData = visibleData.filter(d => d.uniqueId !== hoveredUniqueId);

    // --- 10b. First Pass: Draw all non-hovered points ---
    switch (this.currentView) {
      case 'standard': this.drawStandardView(nonHoveredData, rowHeight, visibleLeft, visibleRight, false, this.mainCtx); break;
      case 'calendar': this.drawCalendarView(nonHoveredData, rowHeight, visibleLeft, visibleRight, false, this.mainCtx); break;
      case 'time': this.drawTimeView(nonHoveredData, rowHeight, visibleLeft, visibleRight, false, this.mainCtx); break;
    }

    // --- 10c. Second Pass (Hover) is now handled by drawHighlight() ---

    // --- END: MODIFIED STEP 10 ---

    // --- 11. Restore Contexts ---
    [this.mainCtx, this.pickingCtx].forEach(ctx => ctx.restore());

    // --- 12. Update Brush ---
    if (!this.isBrushing) {
      this.updateBrushFromTransform('x');
      this.updateBrushFromTransform('y');
    }

    // --- 13. NEW: Redraw the highlight layer ---
    // This ensures the highlight is correct after a pan/zoom/re-render
    this.drawHighlight();
  }

  /**
   * Instantly updates the SVG crosshair lines without re-rendering the canvas.
   */
  private updateCrosshairs(): void {
    if (!this.crosshairSvg) return;

    if (this.hoverState) {
      const { screenX, screenY } = this.hoverState;
      const width = this.mainCanvas.clientWidth;
      const height = this.mainCanvas.clientHeight;

      // Update Vertical Line
      this.crosshairSvg.select('.crosshair-x')
        .attr('x1', screenX)
        .attr('x2', screenX)
        .attr('y1', 0)
        .attr('y2', height)
        .style('visibility', 'visible');

      // Update Horizontal Line
      this.crosshairSvg.select('.crosshair-y')
        .attr('x1', 0)
        .attr('x2', width)
        .attr('y1', screenY)
        .attr('y2', screenY)
        .style('visibility', 'visible');
    } else {
      // Hide them if no hover state
      this.crosshairSvg.selectAll('line')
        .style('visibility', 'hidden');
    }
  }


  // ADD these new, focused drawing functions to your class
  private drawStandardView(
    data: PixelData[],
    rowHeight: number,
    visibleLeft: number,
    visibleRight: number,
    isHighlightPass: boolean = false,
    ctx: CanvasRenderingContext2D = this.mainCtx // <-- ADD PARAMS
  ): void {
    // --- START: MODIFIED FOR RECTANGLES ---
    // These are all in "world" coordinates
    const worldCellWidth = 12; // From your cx_standard calculation: (colIndex * 12)
    const verticalPaddingFraction = 0.1; // 10% padding top/bottom
    const horizontalPaddingFraction = 0.1; // 10% padding left/right
    const worldCornerRadius = 1; // A 1px world-space corner radius

    // Calculate the dimensions of the rectangle with padding
    const worldRectHeight = rowHeight * (1 - (verticalPaddingFraction * 2)); // e.g., 10 * 0.8 = 8
    const worldRectWidth = worldCellWidth * (1 - (horizontalPaddingFraction * 2)); // e.g., 12 * 0.8 = 9.6

    // Calculate the top/left offset from the start of the cell
    const worldYOffset = rowHeight * verticalPaddingFraction; // e.g., 10 * 0.1 = 1
    const worldXOffset = worldCellWidth * horizontalPaddingFraction; // e.g., 12 * 0.1 = 1.2

    data.forEach(d => {
      // Calculate top-left corner of the padded rectangle
      const x = (d.colIndex * worldCellWidth) + worldXOffset;

      // Culling (check if the rect is visible)
      if (x + worldRectWidth < visibleLeft || x > visibleRight) return;

      // Calculate top-left corner
      const y = (d.rowIndex * rowHeight) + worldYOffset;

      ctx.fillStyle = this.statusColorMapColorFn(d);

      // Draw the rounded rectangle in world-space.
      // renderMain() has already set the correct transform on the context.
      this.drawRoundedRect(ctx, x, y, worldRectWidth, worldRectHeight, worldCornerRadius);
      ctx.fill();

      // --- Draw border if this is the highlight pass ---
      if (isHighlightPass) {
        ctx.strokeStyle = '#333'; // Dark grey border
        // Make the border 1.5px in *screen space* by dividing by the zoom
        ctx.lineWidth = 1.5 / this.viewTransform.kx;
        ctx.stroke();
      }
      // --- END: MODIFIED FOR RECTANGLES ---
    });
  }

  private drawCalendarView(
    data: PixelData[],
    rowHeight: number,
    visibleLeft: number,
    visibleRight: number,
    isHighlightPass: boolean = false,
    ctx: CanvasRenderingContext2D = this.mainCtx
  ): void {
    if (this.extendBlocks) {
      // When extendBlocks is TRUE, we want the extended block view.
      // We pass the data directly and let drawLinearViewExtendedWithClustering handle the individual blocks.
      this.drawLinearViewExtendedWithClustering(data, rowHeight, visibleLeft, visibleRight, 'calendar', isHighlightPass, ctx);
    } else {
      // When extendBlocks is FALSE, we want the clustered circles/squares view.
      this.drawLinearViewWithClustering(data, rowHeight, visibleLeft, visibleRight, 'calendar', isHighlightPass, ctx);
    }
  }

  private drawTimeView(
    data: PixelData[],
    rowHeight: number,
    visibleLeft: number,
    visibleRight: number,
    isHighlightPass: boolean = false,
    ctx: CanvasRenderingContext2D = this.mainCtx
  ): void {
    if (this.extendBlocks) {
      // When extendBlocks is TRUE, we want the extended block view.
      // We pass the data directly and let drawLinearViewExtendedWithClustering handle the individual blocks.
      this.drawLinearViewExtendedWithClustering(data, rowHeight, visibleLeft, visibleRight, 'time', isHighlightPass, ctx);
    } else {
      // When extendBlocks is FALSE, we want the clustered circles/squares view.
      this.drawLinearViewWithClustering(data, rowHeight, visibleLeft, visibleRight, 'time', isHighlightPass, ctx);
    }
  }

  /**
   * Clears and redraws the highlight canvas with only the currently hovered point or cluster.
   */
  private drawHighlight(): void {
    if (!this.highlightCtx) return;

    const ctx = this.highlightCtx;
    const dpr = window.devicePixelRatio || 1;

    // 1. Clear the canvas
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    // 2. Check for hover state
    if (!this.hoverState) return;

    const { hoveredData } = this.hoverState;
    if (!hoveredData || hoveredData.length === 0) return;

    // 3. Set transform
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.save();
    ctx.translate(this.viewTransform.x, this.viewTransform.y);
    ctx.scale(this.viewTransform.kx, this.viewTransform.ky);

    // 4. Calculate culling bounds
    const visibleLeft = -this.viewTransform.x / this.viewTransform.kx;
    const visibleRight = visibleLeft + ctx.canvas.clientWidth / this.viewTransform.kx;

    // --- Draw based on view and state ---
    const view = this.currentView;

    if (view === 'standard') {
      // Standard view always draws single points
      this.drawStandardView(hoveredData, this.rowHeight, visibleLeft, visibleRight, true, ctx);

    } else if (view === 'calendar' || view === 'time') {

      if (this.extendBlocks) {
        // --- Draw ONE aggregated extended block ---
        // We pass the full cluster data, and the function will draw it as one block
        this.drawLinearViewExtendedWithClustering(hoveredData, this.rowHeight, visibleLeft, visibleRight, view, true, ctx);

      } else {
        // --- Draw one cluster (circle) or one point (square) ---
        this.drawLinearViewWithClustering(hoveredData, this.rowHeight, visibleLeft, visibleRight, view, true, ctx);
      }
    }
    // 6. Restore context
    ctx.restore();
  }

  private clampTransform(): void {
    const { width, height } = this.currentDimensions;
    if (!width || !height) return;

    // ---Read kx, ky, x, y ---
    const { kx, ky, x, y } = this.viewTransform;
    // --- Read ky ---
    const yScale = this.viewTransform.ky;

    // --- THIS IS THE FIX ---
    // Use this.yAxisWidth (80) to match renderMain
    const yAxisWidth = this.showPatientIDs ? this.yAxisWidth : 0;
    const headerHeight = this.currentView === 'standard' ? 0 : 30;
    const viewWidth = this.mainCanvas.clientWidth - yAxisWidth;
    const viewHeight = this.mainCanvas.clientHeight - headerHeight;

    // --- Use kx ---
    const scaledWidth = width * kx;
    const scaledHeight = height * yScale; // (yScale is already ky)

    // Clamp X
    if (scaledWidth > viewWidth) {
      this.viewTransform.x = Math.max(viewWidth - scaledWidth, Math.min(x, 0));
    } else {
      this.viewTransform.x = 0;
    }

    // Clamp Y
    if (scaledHeight > viewHeight) {
      this.viewTransform.y = Math.max(viewHeight - scaledHeight, Math.min(y, 0));
    } else {
      this.viewTransform.y = 0;
    }
  }

  // @ts-nocheck

  private applyZoom(newScale: number, zoomCenter: { x: number, y: number }): void {
    // --- 1. Capture START state (only if no animation is running) ---
    // This is the core fix for the "jumpy" bug.
    if (!this.animationTimer) {
      this.animationState.startX = this.viewTransform.x;
      this.animationState.startY = this.viewTransform.y;
      this.animationState.startKx = this.viewTransform.kx;
      this.animationState.startKy = this.viewTransform.ky;
      this.animationState.startIsLinear = this.viewTransform.kx < this.linearViewThreshold;
    }
    const oldIsLinear = this.animationState.startIsLinear;

    // --- 2. Calculate NEW target ---

    // --- NEW LOGIC: Calculate target Kx and Ky independently ---
    // targetKx is clamped by the general min/max zoom
    const targetKx = Math.max(this.minZoom, Math.min(newScale, this.maxZoom));

    // targetKy is scaled PROPORTIONALLY to the change in Kx to preserve aspect ratio
    const zoomRatio = targetKx / this.animationState.startKx;
    const rawTargetKy = this.animationState.startKy * zoomRatio;
    const targetKy = Math.max(this.minKy, Math.min(rawTargetKy, this.maxZoom));

    // If *neither* scale has changed, we can return.
    // Check against the last *target* (endK_x) if an animation is running, or the current state if not.
    const prevKx = this.animationState.endK_x || this.viewTransform.kx;
    const prevKy = this.animationState.endK_y || this.viewTransform.ky;

    if (Math.abs(targetKx - prevKx) < 1e-6 && Math.abs(targetKy - prevKy) < 1e-6) {
      return;
    }
    // --- END NEW LOGIC ---

    const newIsLinear = targetKx < this.linearViewThreshold; // X-axis zoom still controls the view
    const thresholdCrossed = oldIsLinear !== newIsLinear && (this.currentView === 'time' || this.currentView === 'calendar');

    // --- 3. Calculate initial target pan ---
    // We must interpolate from the *true start* of the animation
    // This now correctly uses the independent Kx and Ky
    let targetX = zoomCenter.x - (zoomCenter.x - this.animationState.startX) * (targetKx / this.animationState.startKx);
    let targetY = zoomCenter.y - (zoomCenter.y - this.animationState.startY) * (targetKy / this.animationState.startKy);

    // --- 4. ANCHORING CORRECTION ---
    if (thresholdCrossed) {
      const worldX_start = (zoomCenter.x - this.animationState.startX) / this.animationState.startKx;
      const worldY_start = (zoomCenter.y - this.animationState.startY) / this.animationState.startKy;
      let worldX_end, worldY_end;
      worldY_end = worldY_start;

      const bisector = d3.bisector((d: any) => d.x).left;
      if (this.currentView === 'time' && this.timeScaleLinear) {
        if (oldIsLinear) { // linear -> band
          const dataValue_Day = this.timeScaleLinear.invert(worldX_start);
          const day = Math.floor(dataValue_Day);
          const subDayFraction = dataValue_Day - day;
          const bandLayout = this.timeBasedLayout.dayPositions.get(day);
          if (bandLayout) {
            worldX_end = bandLayout.x + (subDayFraction * bandLayout.width);
          }
        } else { // band -> linear
          const index = bisector(this.timeLayoutSorted, worldX_start);
          // --- FIX: Handle index 0 ---
          const foundLayout = index === 0 ? this.timeLayoutSorted[0] : this.timeLayoutSorted[index - 1];
          let day, subDayFraction = 0;
          if (foundLayout) {
            day = foundLayout.day;
            subDayFraction = foundLayout.width > 0 ? (worldX_start - foundLayout.x) / foundLayout.width : 0;
            subDayFraction = Math.max(0, Math.min(1, subDayFraction));
          }
          if (day !== undefined) {
            worldX_end = this.timeScaleLinear(day + subDayFraction);
          }
        }
      } else if (this.currentView === 'calendar' && this.dateScaleLinear) {
        const toDateKey = d3.timeFormat("%Y-%m-%d");
        if (oldIsLinear) { // linear -> band
          const dataValue_Date = this.dateScaleLinear.invert(worldX_start);
          const dateKey = toDateKey(dataValue_Date);
          const dayStart = d3.timeDay.floor(dataValue_Date);
          const subDayFraction = (dataValue_Date.getTime() - dayStart.getTime()) / (1000 * 60 * 60 * 24);
          const bandLayout = this.calendarLayout.datePositions.get(dateKey);
          if (bandLayout) {
            worldX_end = bandLayout.x + (subDayFraction * bandLayout.width);
          }
        } else { // band -> linear
          const index = bisector(this.calendarLayoutSorted, worldX_start);
          // --- FIX: Handle index 0 ---
          const foundLayout = index === 0 ? this.calendarLayoutSorted[0] : this.calendarLayoutSorted[index - 1];
          let dateKey, subDayFraction = 0;
          if (foundLayout) {
            dateKey = foundLayout.dateKey;
            subDayFraction = foundLayout.width > 0 ? (worldX_start - foundLayout.x) / foundLayout.width : 0;
            subDayFraction = Math.max(0, Math.min(1, subDayFraction));
          }
          if (dateKey) {
            const dayStart = new Date(dateKey).getTime();
            worldX_end = this.dateScaleLinear(new Date(dayStart + (subDayFraction * (1000 * 60 * 60 * 24))));
          }
        }
      }

      if (worldX_end === undefined) worldX_end = worldX_start;
      if (worldY_end === undefined) worldY_end = worldY_start;

      const worldShiftX = worldX_end - worldX_start;
      const worldShiftY = worldY_end - worldY_start;
      targetX -= (worldShiftX * targetKx);
      targetY -= (worldShiftY * targetKy);
    }

    // --- 5. Update animation state ---
    this.animationState.endX = targetX;
    this.animationState.endY = targetY;
    this.animationState.endK_x = targetKx;
    this.animationState.endK_y = targetKy;
    this.animationState.endIsLinear = newIsLinear;
    this.animationState.duration = thresholdCrossed ? 600 : 100;

    // --- 6. Start timer (if not already running) ---
    if (!this.animationTimer) {
      this.animationTimer = d3.timer(elapsed => {
        const duration = this.animationState.duration || 100;
        const t = Math.min(1, elapsed / duration);
        const easedT = d3.easeCubicOut(t);

        if (this.animationState.startIsLinear !== this.animationState.endIsLinear) {
          this.animationState.isRunning = true;
          this.animationState.t = easedT;
        }

        this.viewTransform.x = d3.interpolate(this.animationState.startX, this.animationState.endX)(easedT);
        this.viewTransform.y = d3.interpolate(this.animationState.startY, this.animationState.endY)(easedT);
        this.viewTransform.kx = d3.interpolate(this.animationState.startKx, this.animationState.endK_x)(easedT);
        this.viewTransform.ky = d3.interpolate(this.animationState.startKy, this.animationState.endK_y)(easedT);

        this.clampTransform();
        this.renderMain();

        if (t === 1) {
          this.animationTimer.stop();
          this.animationTimer = null;
          this.animationState.isRunning = false;
          // Clear start state
          this.animationState.startX = undefined;
        }
      });
    }
  }
  /**
 * A helper to find the specific data point at a given canvas x/y coordinate.
 * This is used to find the anchor point for zooming.
 */
  private findDataAtCanvasPoint(canvasX: number, canvasY: number): PixelData | null {
    if (!this.mainCanvas) return null;

    // 1. Convert canvas-relative screen to world coords
    // We use the *current* transform state (before the new zoom)
    const worldX = (canvasX - this.viewTransform.x) / this.viewTransform.kx;
    const worldY = (canvasY - this.viewTransform.y) / this.viewTransform.ky;

    // 2. Find the row
    const rowHeight = this.rowHeight; // Must match rowHeight in renderMain
    const rowIndex = Math.floor(worldY / rowHeight);
    // Search the full page data, not just visible data
    const patientEvents = this.allPixelData.filter(p => p.rowIndex === rowIndex);
    if (patientEvents.length === 0) return null;

    // 3. Find the specific point in the row
    let foundPoint: PixelData | null = null;
    const isLinearView = this.viewTransform.kx < this.linearViewThreshold;
    // const linearPixelRadius = (this.linearPixelSize || 8) / 2; // <-- REMOVED (Buggy)

    if (this.currentView === 'standard') {
      const cellSize = 12;
      const colIndex = Math.floor(worldX / cellSize);
      foundPoint = patientEvents.find(p => p.colIndex === colIndex) || null;

    } else if (this.currentView === 'calendar') {
      if (isLinearView) {
        // --- NEW (Rectangle-based check) ---
        foundPoint = patientEvents.find(p => {
          const coords = this.getInterpolationCoords(p, rowHeight);
          if (coords.linearX === undefined || coords.linearW === undefined) return false;
          if (worldY < coords.linearY || worldY > (coords.linearY + coords.linearH)) return false;
          return worldX >= coords.linearX && worldX <= (coords.linearX + coords.linearW);
        }) || null;
      } else {
        // --- NEW (Rectangle-based check, respects extendBlocks) ---
        foundPoint = patientEvents.find(p => {
          const coords = this.getInterpolationCoords(p, rowHeight);
          if (coords.bandX === undefined || coords.bandW === undefined) return false;
          if (worldY < coords.bandY || worldY > (coords.bandY + coords.bandH)) return false;
          return worldX >= coords.bandX && worldX <= (coords.bandX + coords.bandW);
        }) || null;
      }

    } else { // 'time' view
      if (isLinearView) {
        // --- NEW (Rectangle-based check) ---
        foundPoint = patientEvents.find(p => {
          const coords = this.getInterpolationCoords(p, rowHeight);
          if (coords.linearX === undefined || coords.linearW === undefined) return false;
          if (worldY < coords.linearY || worldY > (coords.linearY + coords.linearH)) return false;
          return worldX >= coords.linearX && worldX <= (coords.linearX + coords.linearW);
        }) || null;
      } else {
        // --- NEW (Rectangle-based check, respects extendBlocks) ---
        foundPoint = patientEvents.find(p => {
          const coords = this.getInterpolationCoords(p, rowHeight);
          if (coords.bandX === undefined || coords.bandW === undefined) return false;
          if (worldY < coords.bandY || worldY > (coords.bandY + coords.bandH)) return false;
          return worldX >= coords.bandX && worldX <= (coords.bandX + coords.bandW);
        }) || null;
      }
    }

    // --- REMOVED (Buggy fallback logic) ---

    return foundPoint || null;
  }

  /**
   * A DRY helper to get all coordinates needed for interpolation
   * for a given data point.
   */
  private getInterpolationCoords(d: PixelData, rowHeight: number): {
    linearX?: number, linearY?: number, linearW?: number, linearH?: number,
    bandX?: number, bandY?: number, bandW?: number, bandH?: number
  } {
    // const linearPixelSize = 8; // OLD
    // --- NEW: Get screen size and calculate dynamic world size ---
    const screenPixelSize = this.constantPixelSize;
    const worldPixelWidth = screenPixelSize / this.viewTransform.kx;
    const worldPixelHeight = screenPixelSize / this.viewTransform.ky;
    // --- END NEW ---

    const y = d.rowIndex * rowHeight;
    let cx_linear, cx_band, cw_band, next_cx_linear, next_cx_band;

    if (this.currentView === 'calendar') {
      cx_linear = d.cx_linear_calendar;
      cx_band = d.cx_band_calendar;
      cw_band = d.cw_band_calendar;
      next_cx_linear = d.next_cx_linear_calendar;
      next_cx_band = d.next_cx_band_calendar;
    } else if (this.currentView === 'time') {
      cx_linear = d.cx_linear_time;
      cx_band = d.cx_band_time;
      cw_band = d.cw_band_time;
      next_cx_linear = d.next_cx_linear_time;
      next_cx_band = d.next_cx_band_time;
    } else {
      return {}; // Not applicable for 'standard' view
    }

    if (this.extendBlocks) {
      // --- 1. EXTENDED BLOCK LOGIC ---
      // Ensure a minimum 1-pixel *screen* width
      const minWorldWidth = 1 / this.viewTransform.kx;

      // --- Linear ---
      const linearX = cx_linear;
      // If it's the last event, use the constant size as a fallback width
      const linearW_raw = (next_cx_linear !== undefined)
        ? (next_cx_linear - cx_linear)
        : (this.constantPixelSize / this.viewTransform.kx);
      const linearW = Math.max(minWorldWidth, linearW_raw);
      const linearY = y; // Align to top of row
      const linearH = rowHeight; // Full row height

      // --- Band ---
      const bandX = cx_band;
      // If it's the last event, use its original band width as fallback
      const bandW_raw = (next_cx_band !== undefined)
        ? (next_cx_band - cx_band)
        : cw_band;
      const bandW = Math.max(minWorldWidth, bandW_raw ?? minWorldWidth);
      const bandY = y; // Align to top of row
      const bandH = rowHeight; // Full row height

      return { linearX, linearY, linearW, linearH, bandX, bandY, bandW, bandH };

    } else {
      // --- 2. CONSTANT SIZE LOGIC (from previous answer) ---
      const screenPixelSize = this.constantPixelSize;
      const worldPixelWidth = screenPixelSize / this.viewTransform.kx;
      const worldPixelHeight = screenPixelSize / this.viewTransform.ky;

      // --- Linear ---
      const linearX = cx_linear ? cx_linear - (worldPixelWidth / 2) : undefined;
      const linearW = worldPixelWidth;
      const linearY = y + (rowHeight / 2) - (worldPixelHeight / 2); // Center in row
      const linearH = worldPixelHeight;

      // --- Band ---
      const bandX = (cx_band !== undefined && cw_band !== undefined)
        ? cx_band + (cw_band / 2) - (worldPixelWidth / 2) // Center in original band
        : undefined;
      const bandW = worldPixelWidth;
      const bandY = y + (rowHeight / 2) - (worldPixelHeight / 2); // Center in row
      const bandH = worldPixelHeight;

      return { linearX, linearY, linearW, linearH, bandX, bandY, bandW, bandH };
    }
  }


  /**
   * Stops any active animation timer and resets the state.
   * Does NOT jump to the end state, allowing the next animation
   * to start from the current (in-progress) transform.
   */
  private stopAnimation(): void {
    if (this.animationTimer) {
      this.animationTimer.stop();
      this.animationTimer = null;
    }
    // We only reset the isRunning flag. We leave viewTransform as-is.
    this.animationState.isRunning = false;
  }

  @Input() makeYAxisLinks: boolean = true;

  // --- REWRITTEN: Draws SVG labels with background rectangles for hover effect ---
  private drawYAxis(rowHeight: number, yAxisLabelWidth: number, headerHeight: number): void {
    if (!this.showPatientIDs || !this.yBrushSvg) {
      if (this.yBrushSvg) this.yBrushSvg.select('.y-axis-labels').selectAll('*').remove();
      return;
    }

    const patientIds = this.patientIdsForPage;
    if (!patientIds || patientIds.length === 0) return;

    const { y: translationY, ky: yScale } = this.viewTransform;

    // Determine visible rows (same logic as before)
    const visibleTop = -translationY / yScale;
    const visibleBottom = visibleTop + (this.mainCanvas.clientHeight - headerHeight) / yScale;
    const startRow = Math.max(0, Math.floor(visibleTop / rowHeight));
    const endRow = Math.min(this.patientIdsForPage.length, Math.ceil(visibleBottom / rowHeight) + 1);

    // Get only the patient IDs that should be visible
    const visiblePatientIds = this.patientIdsForPage.slice(startRow, endRow)
      .map((id, index) => ({ id: id, originalIndex: startRow + index }));

    // D3 Data Join for labels
    // We now bind to GROUPS instead of just text
    this.yBrushSvg.select('.y-axis-labels')
      .selectAll('g.y-axis-label-group')
      .data(visiblePatientIds, (d: any) => d.id)
      .join(
        enter => {
          const g = enter.append('g')
            .attr('class', 'y-axis-label-group')
            .style('cursor', this.makeYAxisLinks ? 'pointer' : 'default')
            .style('pointer-events', this.makeYAxisLinks ? 'all' : 'none');

          // Background Rectangle (Initially transparent)
          g.append('rect')
            .attr('class', 'label-bg')
            .attr('fill', 'transparent')
            .attr('rx', 4) // Rounded corners
            .attr('ry', 4);

          // Text Label
          g.append('text')
            .attr('class', 'label-text')
            .attr('dy', '0.35em') // vertically center
            .style('text-anchor', 'end')
            .style('font-size', '11px')
            .style('font-family', 'Poppins')
            .style('fill', this.makeYAxisLinks ? '#4a90e2' : '#333')
            .style('text-decoration', 'none')
            .text((d: any) => d.id);

          return g;
        },
        update => {
           update
             .style('cursor', this.makeYAxisLinks ? 'pointer' : 'default')
             .style('pointer-events', this.makeYAxisLinks ? 'all' : 'none');

           update.select('text')
             .style('fill', this.makeYAxisLinks ? '#4a90e2' : '#333');

           return update;
        },
        exit => exit.remove()
      )
      // Positioning and Sizing
      .attr('transform', (d: any) => {
          const yPos = (d.originalIndex * rowHeight + rowHeight / 2) * yScale + translationY + headerHeight;
          // We position the GROUP at the correct Y. X will be handled relative to this.
          return `translate(0, ${yPos})`;
      })
      .each(function(d: any) {
         // Post-processing to size the rectangle based on text
         const group = d3.select(this);
         const text = group.select('text');
         const rect = group.select('rect');
         const labelWidth = yAxisLabelWidth; // Using the component's property logic
         
         // We position the text at x = labelWidth - 2 (padding)
         text.attr('x', labelWidth - 2);

         let bbox: SVGRect | undefined;
         try {
             bbox = (text.node() as SVGTextElement).getBBox();
         } catch (e) {}

         if (bbox) {
             // Add some padding
             const padX = 4;
             const padY = 2;
             
             rect
               .attr('x', bbox.x - padX)
               .attr('y', bbox.y - padY)
               .attr('width', bbox.width + (padX * 2))
               .attr('height', bbox.height + (padY * 2));
         }
      })
      .on('click', (event: any, d: any) => {
          if (this.makeYAxisLinks) {
              this.goToPrescriberCard(d.id);
          }
      });
      
    // Initial class set based on current hover state (e.g. if re-rendering while hovering)
    this.updateYAxisHover(); 
  }

  /**
   * Updates only the hover classes on the Y-axis labels without a full re-render.
   */
  private updateYAxisHover(): void {
    if (!this.yBrushSvg) return;

    const hoveredId = this.hoverState?.patientId;

    const groups = this.yBrushSvg.select('.y-axis-labels')
      .selectAll('g.y-axis-label-group');
      
    groups.classed('is-hovered', (d: any) => d.id === hoveredId);

    // Bring the hovered group to the front so it overlaps neighbors correctly
    if (hoveredId) {
      groups.filter((d: any) => d.id === hoveredId).raise();
    }
  }

  /**
   * Draws the x-axis now using SVG (header), switching between a linear and band scale based on zoom.
   */
  private drawHeader(tickData: any[]): void {
    if (this.currentView === 'standard' || !this.headerSvg) {
      if (this.headerSvg) this.headerSvg.select('.header-labels').selectAll('*').remove();
      return;
    }

    const { kx: scale, x: translationX } = this.viewTransform;

    const labelsGroup = this.headerSvg.select('.header-labels')
      .attr('transform', `translate(${translationX}, ${this.headerHeight / 2})`);

    // =================================================================
    // --- LOGIC REMOVED ---
    // All the complex filtering logic (everyDayThreshold, etc.)
    // is no longer needed. We will just bind ALL the tickData.
    // =================================================================
    const labelsToRender = tickData; // We render ALL ticks first

    // --- D3 Data Join ---
    labelsGroup.selectAll('g.tick')
      .data(labelsToRender, (d: any) => d.id)
      .join(
        enter => {
          const tickGroup = enter.append('g')
            .attr('class', 'tick')
            // We must apply the transform here
            .attr('transform', (d: any) => `translate(${d.x * scale}, 0)`);

          tickGroup.append('line')
            .attr('y1', -6)
            .attr('y2', 6)
            .attr('stroke', '#333')
            .attr('stroke-width', 1);

          tickGroup.append('text')
            .attr('x', 4)
            .attr('dy', '0.35em')
            .style('font-size', '12px')
            .style('font-family', 'sans-serif')
            .style('fill', '#333')
            .text((d: any) => d.label);

          return tickGroup;
        },
        update => {
          // Make sure to update the transform before collision detection
          update.attr('transform', (d: any) => `translate(${d.x * scale}, 0)`);
          update.select('line').attr('stroke-width', 1);
          return update;
        },
        exit => exit.remove()
      )
      // =================================================================
      // --- NEW ---
      // After all labels are created/updated, call our collision function.
      // We bind 'this' to ensure it can be called correctly.
      .call(this.filterOverlappingLabels.bind(this));
    // =================================================================
  }

  /**
   * A helper function that filters overlapping SVG labels.
   * It is called by d3.call() on a selection of <g class="tick"> elements.
   * @param selection A D3 selection of all <g class="tick"> elements.
   */
  /**
   * A helper function that filters overlapping SVG labels.
   * It is called by d3.call() on a selection of <g class="tick"> elements.
   * @param selection A D3 selection of all <g class="tick"> elements.
   */
  private filterOverlappingLabels(selection: d3.Selection<SVGGElement, any, any, any>): void {
    // =================================================================
    // --- FIX: Reset all ticks to be visible BEFORE measuring ---
    // This clears any 'display: none' from the previous render,
    // ensuring getBoundingClientRect() returns correct values.
    selection.style('display', null);
    // =================================================================

    // 1. Initialize a variable to track the end position of the last visible label.
    //    We use screen coordinates, so -Infinity is a safe starting point.
    let previousLabelEnd = -Infinity;

    // 2. Define the minimum pixel gap you want between labels.
    const padding = 8; // 5px padding

    // 3. Get the raw <g> nodes and sort them based on their 'x' data value.
    //    This is crucial, as selection.nodes() doesn't guarantee left-to-right order.
    const sortedNodes = selection.nodes().sort((a, b) => {
      const dataA = d3.select<SVGGElement, any>(a).datum();
      const dataB = d3.select<SVGGElement, any>(b).datum();
      return dataA.x - dataB.x;
    });

    // 4. Loop through the *sorted* nodes.
    sortedNodes.forEach(node => {
      const tickGroup = d3.select<SVGGElement, any>(node);
      const textEl = tickGroup.select<SVGTextElement>('text').node();

      if (!textEl) return; // Skip if no text element

      // 5. Get the label's *actual* rendered position and size on the screen.
      //    This now works correctly because the element is visible.
      const rect = textEl.getBoundingClientRect();
      const currentLabelStart = rect.left;

      // 6. The Collision Check:
      if (currentLabelStart < previousLabelEnd + padding) {
        // This label overlaps! Hide its parent <g> group.
        tickGroup.style('display', 'none');
      } else {
        // This label does *not* overlap.
        // It's already visible, so we just update the tracker.
        previousLabelEnd = rect.right; // Update the end position
      }
    });
  }

  private getVisibleTickData(): any[] {
    if (this.currentView === 'standard' || !this.headerSvg) {
      return [];
    }

    const { kx: scale } = this.viewTransform;

    let tickData = [];

    // --- NEW: ALWAYS USE LINEAR AXIS ---
    const desiredTickSpacing = 60; // Target ~60px between ticks
    const totalScaledWidth = (this.currentDimensions.width || 10000) * scale;
    const numTicks = Math.max(2, Math.floor(totalScaledWidth / desiredTickSpacing));

    // --- FIX: Force single-day granularity if zoom level allows ---
    // Calculate pixels per day to see if we have enough space (e.g., > 50px/day)
    // World width = 10000. Total days approx depends on domain.
    // Let's assume average density.
    // Safest way: Check the domain that corresponds to 1 tick.
    
    if (this.currentView === 'calendar' && this.dateScaleLinear) {
      // Check if we can show every day
      const domain = this.dateScaleLinear.domain();
      const totalDays = (domain[1].getTime() - domain[0].getTime()) / (1000 * 60 * 60 * 24);
      const pxPerDay = totalScaledWidth / totalDays;

      let ticks;
      let tickFormat;

      if (pxPerDay > 40) { // If > 40px per day, show every day
         ticks = this.dateScaleLinear.ticks(d3.timeDay.every(1));
         tickFormat = this.dateScaleLinear.tickFormat(undefined, "%d"); // Just day number
      } else {
         ticks = this.dateScaleLinear.ticks(numTicks);
         tickFormat = this.dateScaleLinear.tickFormat(numTicks);
      }

      tickData = ticks.map(date => ({
        id: date.getTime(),
        x: this.dateScaleLinear(date),
        label: tickFormat(date)
      }));
    }
    else if (this.currentView === 'time' && this.timeScaleLinear) {
      // Check if we can show every day
      const domain = this.timeScaleLinear.domain();
      const totalDays = domain[1] - domain[0];
      const pxPerDay = totalScaledWidth / totalDays;

      let ticks;
      if (pxPerDay > 40) {
         // Generate integer ticks for every day
         const start = Math.ceil(domain[0]);
         const end = Math.floor(domain[1]);
         ticks = d3.range(start, end + 1);
      } else {
         ticks = this.timeScaleLinear.ticks(numTicks);
      }
      
      tickData = ticks.map(day => ({
        id: day,
        x: this.timeScaleLinear(day),
        label: String(day)
      }));
    }

    return tickData;
  }

  private drawGridLines(tickData: any[], totalHeight: number): void {
    if (!this.mainCtx || tickData.length === 0) return;

    this.mainCtx.beginPath();
    this.mainCtx.strokeStyle = '#e0e0e0'; // Light grey grid line color
    // This makes the line width stay 1px wide, regardless of zoom
    this.mainCtx.lineWidth = 1 / this.viewTransform.kx;

    tickData.forEach(tick => {
      // tick.x is already in the correct "world" coordinate
      this.mainCtx.moveTo(tick.x, 0); // Start at the top of the chart area
      this.mainCtx.lineTo(tick.x, totalHeight); // Draw down to the bottom
    });

    this.mainCtx.stroke();
  }

  /**
 * Draws a single, consolidated rectangle for a block of events and adds a descriptive label if space permits.
 * @param blockEvents - An array of consecutive PixelData events.
 * @param color - The color to fill the rectangle with.
 * @param rowHeight - The height of each patient row.
 * @param view - The current view ('time' or 'calendar').
 */
  private _drawAggregatedBlock(blockEvents: PixelData[], color: string, rowHeight: number, view: 'time' | 'calendar'): void {
    if (!blockEvents || blockEvents.length === 0) return;

    const firstEvent = blockEvents[0];
    const lastEvent = blockEvents[blockEvents.length - 1];
    const startX = view === 'time' ? firstEvent.cx_time : firstEvent.cx_calendar;

    let endX;
    if (this.viewTransform.kx < this.linearViewThreshold) {
      endX = view === 'time' ? lastEvent.cx_time : lastEvent.cx_calendar;
    } else {
      endX = view === 'time'
        ? (lastEvent.cx_time + lastEvent.cw_time)
        : (lastEvent.cx_calendar + lastEvent.cw_calendar);
    }

    const rectY = firstEvent.rowIndex * rowHeight;
    const calculatedWidth = endX - startX;

    // --- MODIFIED LINE ---
    // In linear view, enforce a minimum width (e.g., 5px) for visibility.
    // Otherwise, in band view, just ensure it's at least 1px.
    const rectWidth = this.viewTransform.kx < this.linearViewThreshold
      ? Math.max(calculatedWidth, 5)
      : Math.max(1, calculatedWidth);
    // --- END MODIFICATION ---

    // Drawing logic remains the same
    this.mainCtx.fillStyle = color;
    this.mainCtx.fillRect(startX, rectY, rectWidth, rowHeight);

    const statusCount = blockEvents.length;
    const referralStatus = firstEvent.CURRENT_REFERRAL_STATUS || 'N/A';
    const labelText = `${referralStatus} (${statusCount})`;

    this.mainCtx.font = '10px Poppins';
    const textWidth = this.mainCtx.measureText(labelText).width;

    if (rectWidth > textWidth + 10) {
      // --- NEW: Save the scaled context state ---
      this.mainCtx.save();

      // These settings are now applied inside the save/restore block
      this.mainCtx.fillStyle = this._getContrastingTextColor(color);
      this.mainCtx.textAlign = 'center';
      this.mainCtx.textBaseline = 'middle';

      // Calculate the center point in world coordinates (same as before)
      const textX = startX + rectWidth / 2;
      const textY = rectY + rowHeight / 2;

      // --- NEW: Apply inverse-zoom transform ---
      // 1. Move the context origin to the center of the text
      this.mainCtx.translate(textX, textY);
      // 2. Scale the context by the *inverse* of the zoom
      // (Since your kx and ky are the same, we can use kx for both)
      this.mainCtx.scale(1 / this.viewTransform.kx, 1 / this.viewTransform.ky);

      // --- MODIFIED: Draw the text at the new origin (0, 0) ---
      this.mainCtx.fillText(labelText, 0, 0);

      // --- NEW: Restore the context to its original scaled state ---
      this.mainCtx.restore();
    }
  }

  /**
   * A helper function to draw a rectangle with rounded corners on a canvas.
   */
  private drawRoundedRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, radius: number): void {
    // Ensure radius is not larger than half the width or height
    if (w < 2 * radius) radius = w / 2;
    if (h < 2 * radius) radius = h / 2;

    // Ensure radius is positive
    if (radius < 0) radius = 0;

    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.arcTo(x + w, y, x + w, y + h, radius);
    ctx.arcTo(x + w, y + h, x, y + h, radius);
    ctx.arcTo(x, y + h, x, y, radius);
    ctx.arcTo(x, y, x + w, y, radius);
    ctx.closePath();
  }

  /**
 * Calculates whether black or white text is more readable against a given hex color.
 * @param hexColor - The background color in hex format (e.g., '#8859b6').
 * @returns '#000000' (black) for light backgrounds, and '#FFFFFF' (white) for dark backgrounds.
 */
  private _getContrastingTextColor(hexColor: string): string {
    if (!hexColor) return '#000000';

    // Remove the '#' if present
    const hex = hexColor.startsWith('#') ? hexColor.slice(1) : hexColor;

    // Convert hex to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate luminance (per ITU-R BT.709)
    const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

    // Use a threshold of 0.5 to decide between black and white
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  }


  // Helper for converting id to rgb color
  private idToPickingColor(id: number): string {
    const r = (id >> 16) & 0xFF;
    const g = (id >> 8) & 0xFF;
    const b = id & 0xFF;
    return `rgb(${r},${g},${b})`;
  }

  /**
   * Draws the linear view (zoomed out, extendBlocks=false) by clustering
   * overlapping points into circles with a count.
   * @param data The visible PixelData[]
   * @param rowHeight The height of a single row
   * @param visibleLeft The left edge of the viewport in world coordinates
   * @param visibleRight The right edge of the viewport in world coordinates
   * @param view The current view ('calendar' or 'time')
   */
  private drawLinearViewWithClustering(
    data: PixelData[],
    rowHeight: number,
    visibleLeft: number,
    visibleRight: number,
    view: 'calendar' | 'time',
    isHighlightPass: boolean = false,
    ctx: CanvasRenderingContext2D = this.mainCtx
  ): void {
    const dataByRow = d3.group(data, d => d.rowIndex);
    // const screenBoxSize = 16; // OLD
    // Calculate dynamic box size based on current zoom
    const rowHeightScreen = rowHeight * this.viewTransform.ky;
    const targetSize = rowHeightScreen - 2; // Keep a 2px gap
    // Clamp between 8px (min) and 16px (max)
    // Note: minKy should prevent it from going below 8px effectively (if minKy=1.0, rowHeightScreen=10, target=8)
    const screenBoxSize = Math.max(10, Math.min(this.screenBoxSize, targetSize));
     
    const screenRadius = 2; // 2px screen-space radius

    // --- NEW: Physics-like Collision Resolution ---
    // Track the right-most edge of the last drawn element in this row
    // to force a minimum visual gap.    
    let lastRightBodyEdge = -Infinity;
    const minVisualGap = 1; // 1px gap

    for (const [rowIndex, rowData] of dataByRow.entries()) {
      const clusters = this.buildRowClusters(rowData, view, rowHeight);
      
      // Reset for each row
      lastRightBodyEdge = -Infinity;

      for (const cluster of clusters) {
        const count = cluster.count;
        let { worldX, worldY } = cluster;
        const color = this.statusColorMapColorFn(cluster.pixels[0]);

        // 1. Calculate natural screen position first
        const worldPixelWidth = screenBoxSize / this.viewTransform.kx;
        
        // --- COLLISION RESOLUTION ---
        // Only apply if it's a single pixel (not a cluster circle) to strictly fix the "overlap" issue
        // without messing up the circle layout (though circles shouldn't overlap due to clustering logic).
        if (count === 1) { // Implicitly !cluster.isCluster
             const naturalScreenX = worldX * this.viewTransform.kx + this.viewTransform.x;
             const halfSize = screenBoxSize / 2;
             const currentLeft = naturalScreenX - halfSize;
             
             let effectiveLeft = currentLeft;
             
             // Check collision
             if (effectiveLeft < lastRightBodyEdge + minVisualGap) {
                 effectiveLeft = lastRightBodyEdge + minVisualGap;
             }
             
             // Update the "Hard" tracker
             lastRightBodyEdge = effectiveLeft + screenBoxSize;
             
             // Reverse-engineer the "Effective WorldX" needed to draw at this screen location
             // naturalScreenX = worldX * k + x
             // effectiveScreenCenter = effectiveLeft + halfSize
             // effectiveScreenCenter = effectiveWorldX * k + x
             // effectiveWorldX = (effectiveScreenCenter - x) / k
             const effectiveScreenCenter = effectiveLeft + halfSize;
             worldX = (effectiveScreenCenter - this.viewTransform.x) / this.viewTransform.kx;
        } else {
             // For Clusters (circles), we just update the tracker naturally so subsequent pixels don't overlap IT.
             const naturalScreenX = worldX * this.viewTransform.kx + this.viewTransform.x;
             const halfSize = screenBoxSize / 2;
             lastRightBodyEdge = (naturalScreenX - halfSize) + screenBoxSize;
        }

        // 2. Culling (Check modified world coordinates)
        const linearX = worldX - (worldPixelWidth / 2);
        if (linearX > visibleRight || (linearX + worldPixelWidth) < visibleLeft) continue;

        // 3. Save, translate, and scale context
        ctx.save();
        ctx.translate(worldX, worldY);
        ctx.scale(1 / this.viewTransform.kx, 1 / this.viewTransform.ky);

        // 4. Draw shape (now in screen-space coordinates)
        ctx.fillStyle = color;
        const halfSize = screenBoxSize / 2;
        this.drawRoundedRect(ctx, -halfSize, -halfSize, screenBoxSize, screenBoxSize, screenRadius);
        ctx.fill();

        // 5. Draw highlight border (now in screen-space)
        if (isHighlightPass) {
          ctx.strokeStyle = '#333';
          ctx.lineWidth = 1.5; // Simple screen-space line width
          ctx.stroke();
        }

        ctx.restore(); // Restore context *before* drawing text

        // 6. Draw Count Label (ONLY for clusters)
        if (count > 1) {
          ctx.save();
          ctx.translate(worldX, worldY);
          ctx.scale(1 / this.viewTransform.kx, 1 / this.viewTransform.ky);
          ctx.fillStyle = this._getContrastingTextColor(color);
          ctx.font = 'bold 10px Poppins';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(count.toString(), 0, 0);
          ctx.restore();
        }
      }
    }
  }


  /**
  * Draws the *extended* linear view (zoomed out, extendBlocks=true)
  * by clustering points that share the same X-coordinate and drawing
  * a single block with a count.
  * @param data The visible PixelData[]
  * @param rowHeight The height of a single row
  * @param visibleLeft The left edge of the viewport in world coordinates
  * @param visibleRight The right edge of the viewport in world coordinates
  * @param view The current view ('calendar' or 'time')
  */
  private drawLinearViewExtendedWithClustering(
    data: PixelData[],
    rowHeight: number,
    visibleLeft: number,
    visibleRight: number,
    view: 'calendar' | 'time',
    isHighlightPass: boolean = false,
    ctx: CanvasRenderingContext2D = this.mainCtx
  ): void {
    const dataByRow = d3.group(data, d => d.rowIndex);

    const verticalPaddingFraction = 0.1;
    const worldHorizontalPadding = 0.1;
    const screenRadius = 2; // 2px screen-space radius

    for (const [rowIndex, rowData] of dataByRow.entries()) {
      const clusters = this.buildRowClusters(rowData, view, rowHeight);

      for (const cluster of clusters) {
        const count = cluster.count;
        if (count === 0) continue;

        const firstPixel = cluster.pixels[0];

        const y = firstPixel.rowIndex * rowHeight;
        const h = rowHeight;
        const paddedY = y + (h * verticalPaddingFraction);
        const paddedH = h * (1 - (verticalPaddingFraction * 2));

        const startX = (view === 'calendar' ? firstPixel.cx_linear_calendar : firstPixel.cx_linear_time);
        const getEndX = (p: PixelData) => {
          const next_cx = (view === 'calendar' ? p.next_cx_linear_calendar : p.next_cx_linear_time);
          const cx = (view === 'calendar' ? p.cx_linear_calendar : p.cx_linear_time);
          if (next_cx !== undefined) return next_cx;
          if (cx !== undefined) return cx + (this.constantPixelSize / this.viewTransform.kx);
          return 0;
        };
        const endX = d3.max(cluster.pixels, getEndX);
        if (startX === undefined || endX === undefined) continue;

        const w = endX - startX;
        const paddedX = startX + worldHorizontalPadding;
        const paddedW = w - (worldHorizontalPadding * 2);

        if (paddedW <= 0) continue;

        if (paddedX + paddedW < visibleLeft || paddedX > visibleRight) continue;

        const color = this.statusColorMapColorFn(firstPixel);

        ctx.save();
        // Translate to the padded top-left corner
        ctx.translate(paddedX, paddedY);
        // Scale to screen-space
        ctx.scale(1 / this.viewTransform.kx, 1 / this.viewTransform.ky);

        // Calculate screen-space dimensions
        const screenW = paddedW * this.viewTransform.kx;
        const screenH = paddedH * this.viewTransform.ky;

        // Draw the rect at (0, 0) in the new scaled context
        this.drawRoundedRect(ctx, 0, 0, screenW, screenH, screenRadius);
        ctx.fillStyle = color;
        ctx.fill();

        if (isHighlightPass) {
          ctx.strokeStyle = '#333';
          ctx.lineWidth = 1.5; // Now a simple screen-space border
          ctx.stroke();
        }

        ctx.restore(); // Restore before drawing text

        if (cluster.isCluster) {
          ctx.save();
          ctx.translate(paddedX + paddedW / 2, paddedY + paddedH / 2);
          ctx.scale(1 / this.viewTransform.kx, 1 / this.viewTransform.ky);

          ctx.fillStyle = this._getContrastingTextColor(color);
          ctx.font = 'bold 10px Poppins';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';

          const textMetrics = ctx.measureText(count.toString());
          if (textMetrics.width + 5 < paddedW * this.viewTransform.kx) {
            ctx.fillText(count.toString(), 0, 0);
          }
          ctx.restore();
        }
      }
    }
  }

  /**
   * Takes a row of pixel data and groups it into drawable clusters.
   */
  private buildRowClusters(rowData: PixelData[], view: 'calendar' | 'time', rowHeight: number): Cluster[] {
    if (!rowData || rowData.length === 0) {
      return [];
    }

    // Sort pixels in this row by their world X-coordinate
    // We add a tie-breaker (daysFromStart) and MILLISECONDS (STATUS_DATE) to ensure stable sorting.
    const sortedRowData = rowData.sort((a, b) => {
      const xA = (view === 'calendar' ? a.cx_linear_calendar : a.cx_linear_time) ?? 0;
      const xB = (view === 'calendar' ? b.cx_linear_calendar : b.cx_linear_time) ?? 0;
      
      if (Math.abs(xA - xB) > 0.0001) return xA - xB;
      if (a.daysFromStart !== b.daysFromStart) return a.daysFromStart - b.daysFromStart;
      return new Date(a.STATUS_DATE).getTime() - new Date(b.STATUS_DATE).getTime();
    });

    const clusters: Cluster[] = [];
    let currentCluster: Cluster | null = null;
    
    // --- FIX: Use global maxZoom for threshold ---
    // User can tune this multiplier (e.g. 0.9, 0.95) to control when clusters break.
    const declusterThreshold = this.maxZoom * 0.9;
       
    for (const d of sortedRowData) {
      const pixelWorldX = (view === 'calendar' ? d.cx_linear_calendar : d.cx_linear_time);
      if (pixelWorldX === undefined) continue;

      const pixelWorldY = (d.rowIndex * rowHeight) + (rowHeight / 2);
      const pixelScreenX = pixelWorldX * this.viewTransform.kx + this.viewTransform.x;

      // --- FIX: Disable clustering if we are near the max zoom limit ---
      // We rely solely on the calculated threshold
      const isAtMaxZoom = this.viewTransform.kx >= declusterThreshold;

      if (!currentCluster || isAtMaxZoom || (pixelScreenX > currentCluster.screenX + this.linearClusterThreshold)) {
        // Start a new cluster
        if (currentCluster) {
            clusters.push(currentCluster);
        }
        currentCluster = {
            pixels: [d],
            worldX: pixelWorldX,
            worldY: pixelWorldY,
            screenX: pixelScreenX,
            count: 1,
            isCluster: false
        };
      } else {
        // Add to existing cluster and update its average position
        currentCluster.pixels.push(d);
        currentCluster.count++;
        currentCluster.isCluster = true;

        // Recalculate average worldX
        const totalWorldX = currentCluster.pixels.reduce((sum, p) => {
          const x = (view === 'calendar' ? p.cx_linear_calendar : p.cx_linear_time) ?? 0;
          return sum + x;
        }, 0);
        currentCluster.worldX = totalWorldX / currentCluster.count;

        // Update screenX for the *next* comparison
        currentCluster.screenX = currentCluster.worldX * this.viewTransform.kx + this.viewTransform.x;
      }
    }
    // Add the last cluster
    if (currentCluster) {
      clusters.push(currentCluster);
    }

    return clusters;
  }


  /**
   * Draws the Y-axis (Patient ID) hover label in the yBrushSvg.
   */
  private drawHoverYAxisLabel(): void {
    if (!this.yBrushSvg) return;

    const labelGroup = this.yBrushSvg.select('.hover-y-label');

    // Use D3 data join to manage the single label
    const data = this.hoverState ? [this.hoverState] : [];

    const label = labelGroup.selectAll('g.y-hover-box')
      .data(data, (d: any) => d.patientId); // Use patientId as key

    // EXIT: Remove old label
    label.exit().remove();

    // ENTER: Create new label group
    const enterGroup = label.enter()
      .append('g')
      .attr('class', 'y-hover-box');

    enterGroup.append('rect')
      .attr('fill', '#000000ff')
      .attr('rx', 4)
      .attr('ry', 4);

    enterGroup.append('text')
      .attr('fill', 'white')
      .style('font-size', '11px')
      .style('font-family', 'Poppins')
      .attr('text-anchor', 'middle')
      .attr('dy', '0.35em'); // Vertical centering


    const self = this;

    // UPDATE: Position and update text for both new and existing labels
    label.merge(enterGroup)
      // Position vertically based on mouse.
      // Add headerHeight because yBrushSvg is above mainCanvas
      .attr('transform', d => `translate(0, ${d.screenY + this.headerHeight})`)
      .each(function (d) { // 'function' keyword is correct here to get D3's 'this'
        const textEl = d3.select(this).select<SVGTextElement>('text').text(d.patientId);
        const padding = { x: 6, y: 4 };
        let bbox;
        try {
          // Get the rendered size of the text
          bbox = textEl.node()!.getBBox();
        } catch (e) {
          bbox = { x: 0, y: 0, width: 50, height: 12 }; // Fallback
        }

        // Size the rect to fit the text
        d3.select(this).select('rect')
          .attr('x', 0)
          .attr('y', -bbox.height / 2 - padding.y)
          .attr('width', self.yAxisWidth) // <-- FIX: Use 'self'
          .attr('height', bbox.height + padding.y * 2);

        textEl.attr('x', self.yAxisWidth / 2); // <-- FIX: Use 'self'
      });
  }

  /**
   * Draws the X-axis (Date/Day) hover label in the brushSvg.
   */
  private drawHoverXAxisLabel(): void {
    if (!this.headerSvg) return;

    // Do not show the x hover label for standard view
    if (this.currentView === 'standard') {
      this.headerSvg.select('.hover-x-label').selectAll('g.x-hover-box').remove();
      return; // Stop the function here
    }

    const labelGroup = this.headerSvg.select('.hover-x-label');

    // Use D3 data join to manage the single label
    const data = this.hoverState ? [this.hoverState] : [];

    const label = labelGroup.selectAll('g.x-hover-box')
      .data(data, (d: any) => d.xLabel); // Use xLabel as key

    // EXIT: Remove old label
    label.exit().remove();

    // ENTER: Create new label group
    const enterGroup = label.enter()
      .append('g')
      .attr('class', 'x-hover-box');

    enterGroup.append('rect')
      .attr('fill', '#020202ff')
      .attr('rx', 4)
      .attr('ry', 4);

    enterGroup.append('text')
      .attr('fill', 'white')
      .style('font-size', '11px')
      .style('font-family', 'Poppins')
      .attr('text-anchor', 'middle')
      .attr('dy', '0.35em'); // Vertical centering

    const self = this;

    // UPDATE: Position and update text for both new and existing labels
    label.merge(enterGroup)
      // Position horizontally based on mouse.
      // Add yAxisWidth because brushSvg is to the left of mainCanvas
      .attr('transform', d => `translate(${d.screenX}, ${this.headerHeight / 2})`)
      .each(function (d) {
        const textEl = d3.select(this).select<SVGTextElement>('text').text(d.xLabel);
        const padding = { x: 6, y: 4 };
        let bbox;
        try {
          // Get the rendered size of the text
          bbox = textEl.node()!.getBBox();
        } catch (e) {
          bbox = { x: 0, y: 0, width: 80, height: 12 }; // Fallback
        }

        // Size the rect to fit the text
        d3.select(this).select('rect')
          .attr('x', -bbox.width / 2 - padding.x)
          .attr('y', -bbox.height / 2 - padding.y)
          .attr('width', bbox.width + padding.x * 2)
          .attr('height', bbox.height + padding.y * 2);

        textEl.attr('x', 0); // Center text
      });
  }

}
